import {
  ErrorMessage,
  Field,
  Form,
  Formik,
  FormikProps,
  useFormikContext,
} from "formik";
import { observer } from "mobx-react";
import moment from "moment";
import React, {
  ChangeEvent,
  ChangeEventHandler,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import toast from "react-hot-toast";
import { FormattedMessage } from "react-intl";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import demoStoreIcon from "../../assets/Images/teamwork.png";
import {
  formatNumberWithCommas,
  generateWeeklyHours,
  getHoursDifferenceFromNow,
  getOpenTimeFromReservationSettingForCustomerSide,
  isAnyTreatmentInvalidByDate,
  isAnyTreatmentInvalidByStaff,
  isCurrentDateTimeGreater,
  IsStoreClosedByDateBookingCalendar,
  IsStoreClosedByDateForShift,
  isTimeSlotWithinWindow,
  JapaneseHolidays,
  parseDateTime,
} from "../../constants/constants";
import bookingStatusEnum from "../../constants/enums/booking-status-enum";
import { BookingTypeEnum } from "../../constants/enums/booking-type-enum";
import { CancellationTypeEnum } from "../../constants/enums/cancellation-type-enum";
import { CustomerTypeEnum } from "../../constants/enums/customer-type-enum";
import { paymentType } from "../../constants/enums/payment-type-enum";
import { RegisteredByEnum } from "../../constants/enums/registered-by-enum";
import { serviceTypeEnum } from "../../constants/enums/service-type-enum";
import { weekdayShortEnum } from "../../constants/enums/weekday-short-enum";
import RoutesConstants from "../../constants/routes.constant";
import { useStore } from "../../contexts/store-provider";
import headquarterStore from "../../core/stores/headquarter-store";
import { formatTimeDisplay } from "../../helpers/date-time-helper";
import {
  getBlockedStoreIdsCustomerFromLocalStorage,
  getcustIdFromToken,
  getTokenFromLocalStorage,
  getUserTypeFromLocalStorage,
} from "../../helpers/localstorage-helper";
import {
  BookingFormValues,
  StepIndicatorProps,
} from "../../models/forms/IAddBookingManagement";
import { BookingFormSchema } from "../../shared-components/FormikFormHandlers/FormikValidationSchema";
import FormLoader from "../../shared-components/FormLoader/FormLoader";
import CustomerTopNavbar from "../../shared-components/navbar/customer-top-navbar";
import { formatMessage } from "../../translations/format-message";
import LogoutPopup from "../auth/components/logout-popup";
import AuthenticateCustomerAccount from "./authorize-customer-account/components/authenticate-customer-account";
import "./booking-management.css";
import AuthorizeCustomerPopupHOC from "./hoc/authorize-customer-popup-hoc";
import ResetPasswordWindowPopupHOC from "../../shared-components/popup/change-password/reset-password-window-popup-hoc";
import ZeroDurationTreatmentPopup from "../../shared-components/popup/confirm/zero-duration-treatment";
import { BookingManagementStore } from "../../core/stores/booking-management-store";
import { MasterManagementStore } from "../../core/stores/master-management-store";
import { useLizeraStaleStateRecovery } from "../../contexts/lizera-recovery-provider";
import { get } from "lodash";

const initialValues: BookingFormValues = {
  selectedServices: [],
  selectedStaff: -3,
  selectedDate: null,
  agreedToTerms: false,
  dmAgreeToTerms: false,
  agreeToPrecaution: false,
  isTreatmentInvalidByStaff: false,
};

const StepIndicator: React.FC<StepIndicatorProps> = observer(
  ({ currentStep, isStepAccessible }) => {
    const steps = [
      { number: 1, title: formatMessage("choose_a_menu") },
      { number: 2, title: formatMessage("specify_the_date") },
      {
        number: 3,
        title: formatMessage("confirmation_of_reservation_details"),
      },
      { number: 4, title: formatMessage("booking_completed") },
    ];

    return (
      <div className="stepper-wrapper">
        <div className="d-flex position-relative">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`step-item flex-grow-1 text-center ${
                isStepAccessible(step.number) ? "accessible" : ""
              }`}
              onClick={() => isStepAccessible(step.number)}
            >
              <div
                className={`step-number ${
                  currentStep >= step.number ? "active" : ""
                }`}
              >
                {step.number}
              </div>
              <div className="step-title">{step.title}</div>
              {index < steps.length - 1 && (
                <div
                  className={`step-line ${
                    currentStep > step.number ? "active" : ""
                  }`}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
);

const MenuSelectionSummary: React.FC<{
  selectedServices: any[];
}> = observer(({ selectedServices }) => {
  const { values } = useFormikContext<BookingFormValues>();
  const { bookingManagementStore, masterManagementStore } = useStore();
  const { getAllTimeOptions } = masterManagementStore;
  const { accordionData } = bookingManagementStore;

  const getAccordionDataById = (id: number) => {
    let result: any = null;
    accordionData.forEach((items, categoryId) => {
      if (!result) {
        const foundItem = items.find((item: { Id: number }) => item.Id === id);
        if (foundItem) {
          result = foundItem;
        }
      }
    });
    return result;
  };

  const calculateTotals = (servicesSelected:any) => {
    let fee = 0;
    let time = 0;
    let optionTime = 0;
    let optionFee = 0;
    servicesSelected?.map((service: any) => {
      const treatmentData = getAccordionDataById(
        Number(service.TreatmentId)
      );
      const getTreatmentTime = getAllTimeOptions?.find(
        (time) => time.id == (treatmentData?.Time ?? 0)
      )
        ? Number(
            getAllTimeOptions?.find(
              (time) => time.id == (treatmentData?.Time ?? 0)
            )?.value
          )
        : 0;

      service.OptionIds?.map((ids: number) => {
        const option =
          treatmentData?.optionVm?.length > 0
            ? treatmentData?.optionVm?.find((op: any) => op.OptionId == ids)
            : null;
        if (option) {
          optionTime += option?.TimeValue;
          optionFee += option?.FeeIncludingTax;
        }
      });
      fee += treatmentData?.FeeIncludingTax;
      time += getTreatmentTime;
    });
    return { FeeIncludingTax: fee + optionFee, Time: time + optionTime };
  };

  return (
    <>
      {/* Selected Menus Summary Card */}
      <div className="card mb-2 selected_menu_wrap">
        <div className="card-header p-0 row g-0">
          <div className="col-sm-7 col-6">
            <h6 className="mb-0">
              {" "}
              <FormattedMessage id="selected_menu" />
            </h6>
          </div>
          <div className="col-sm-2 col-3 border-start">
            <h6 className="mb-0">
              {" "}
              <FormattedMessage id="fee" />
            </h6>
          </div>
          <div className="col-3 border-start">
            <h6 className="mb-0">
              {" "}
              <FormattedMessage id="time_required" />
            </h6>
          </div>

        </div>
        {values?.selectedServices?.length > 0 && values.selectedServices.map((service: any, index) => (
           <SelectedMenuData key={service?.TreatmentId} data={service} />
        ))}


        <div className="row g-0 border-top card-totals">
          <div className="col-sm-7 col-6 p-3"></div>
          <div className="col-sm-2 col-3 fee_value">
            <i className="bi bi-currency-yen"></i>{" "}
            {values?.selectedServices?.length > 0 &&  
            formatNumberWithCommas(calculateTotals(values.selectedServices).FeeIncludingTax)
            }
          </div>
          <div className="time_value col-3">
            <div>{ values?.selectedServices?.length > 0 &&
            formatTimeDisplay(Number(calculateTotals(values.selectedServices).Time ?? 0))} </div>
          </div>
        </div>
      </div>
    </>
  );
});

const ServiceSelection: React.FC<{
  currentStep: number;
  formikProps: FormikProps<BookingFormValues>;
  storeId: number;
  openNodes: { [key: string]: boolean };
  setOpenNodes: React.Dispatch<
    React.SetStateAction<{ [key: string]: boolean }>
  >;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
}> = observer(({ storeId, openNodes, setOpenNodes }) => {
  // const { values, setFieldValue } = formikProps;
  const { setFieldValue, values } = useFormikContext<BookingFormValues>();
  // const { storeId } = useParams<{ storeId: string }>();
  const {
    categoryManagementStore,
    bookingManagementStore,
    masterManagementStore,
    storeCmsStore,
  } = useStore();
  const { storeCodeDetails } = storeCmsStore;
  const { allCategoryBookingManagement } = categoryManagementStore;
  const { getAllTimeOptions } = masterManagementStore;
  const {
    GetTreatmentOptionMenuListByCatIdCustomerService,
    getData,
    accordionLoading,
    accordionData,
    fetchTreatmentOptionsForAllCategories,
    getSelectedService,
    selectedService,
    getIsSourceFeatured,
  } = bookingManagementStore;

  useEffect(() => {
    if (getSelectedService !== undefined) {
      const index = initialValues.selectedServices.findIndex(
        (service: any) => service.TreatmentId == getSelectedService.TreatmentId
      );
      GetTreatmentOptionMenuListByCatIdCustomerService(
        getSelectedService.CategoryId,
        null,
        storeId,
        storeCodeDetails.BusinessTypeId
      );        
      if (index === -1) {
        initialValues.selectedServices.push({
          TreatmentId: getSelectedService.TreatmentId,
          OptionIds: getSelectedService.OptionIds,
        });
      }
    }
    //  else {
    //   initialValues.selectedServices = [];
    //   setFieldValue("selectedServices", []);
    // }
  }, [selectedService, accordionData, getIsSourceFeatured]);

  // Toggle open/close for a given node id
  const toggleNode = (nodeId: string) => {
    setOpenNodes((prev) => ({
      ...prev,
      [nodeId]: !prev[nodeId],
    }));
  };

  const toggleNodeOpen = (nodeId: string) => {
    setOpenNodes((prev) => ({
      ...prev,
      [nodeId]: true,
    }));
  };

  const handleOptionServiceSelect = (treatmentId: number, optionId: number) => {
    const selectedServices: any[] = [...values.selectedServices];
    const treatmentObj = selectedServices?.find(
      (item) => item.TreatmentId === treatmentId
    );
    let duplicateOptionId = selectedServices.find((item) =>
      item.OptionIds?.includes(optionId)
    );
    if (treatmentObj) {
      // Check if the optionId already exists in the optionIds array
      const optionIndex = treatmentObj.OptionIds?.indexOf(optionId);
      if (duplicateOptionId && duplicateOptionId?.TreatmentId !== treatmentId) {
        toast.error(formatMessage("option_already_selected"));
      } else {
        if (optionIndex === -1) {
          treatmentObj.OptionIds.push(optionId);
        } else {
          treatmentObj.OptionIds.splice(optionIndex, 1);
        }
      }
    } else {
      selectedServices.push({
        TreatmentId: treatmentId,
        OptionIds: duplicateOptionId ? [] : [optionId],
      });
    }
    setFieldValue("selectedServices", selectedServices);
  };

  const handleTreatmentServiceSelect = (treatmentId: number) => {
    const selectedServices: any[] = [...values.selectedServices];
    const index = selectedServices.findIndex(
      (service: any) => service.TreatmentId == treatmentId
    );
    if (index === -1) {
      selectedServices.push({ TreatmentId: treatmentId, OptionIds: [] });
    } else {
      selectedServices.splice(index, 1);
    }
    setFieldValue("selectedServices", selectedServices);
  };

  useEffect(() => {
    if (allCategoryBookingManagement) {
      fetchTreatmentOptionsForAllCategories(
        allCategoryBookingManagement,
        storeId,
        storeCodeDetails.BusinessTypeId
      );
      openAllAccordions();
    }
  }, [allCategoryBookingManagement]);

  const openAllAccordions = () => {
    allCategoryBookingManagement?.map((item) => {
      toggleNodeOpen(`${item.id}-NCT`);
    });
  };

  // Recursive function to render nested children (services)
  const renderNestedServices = (
    subCategories: any[],
    parentPath: string = ""
  ) => {
    return (
      <div className="px-md-3 px-1 mt-2">
        {subCategories?.map((subCategory: any) => {
          const nodeKey = parentPath
            ? `${parentPath}-${subCategory.id}`
            : `${subCategory.id}`;
          return (
            <div key={nodeKey}>
              <button
                type="button"
                className="accordian_btn d-flex justify-content-between align-items-center text-start"
                onClick={() => {
                  toggleNode(nodeKey);
                  GetTreatmentOptionMenuListByCatIdCustomerService(
                    subCategory.id,
                    null,
                    storeId,
                    storeCodeDetails.BusinessTypeId
                  );
                }}
              >
                {subCategory.title}
                {openNodes[nodeKey] ? (
                  <svg
                    fill="currentColor"
                    height="16"
                    viewBox="0 0 367.676 367.676"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <g>
                        <path d="m344.696 287.246c-5.881 0-11.763-2.243-16.249-6.73l-144.61-144.609-144.608 144.609c-8.973 8.975-23.524 8.975-32.498 0-8.974-8.974-8.974-23.524 0-32.498l160.857-160.859c4.31-4.309 10.154-6.731 16.249-6.731 6.094 0 11.94 2.422 16.25 6.731l160.858 160.858c8.974 8.974 8.974 23.524 0 32.498-4.486 4.488-10.368 6.731-16.249 6.731z"></path>
                      </g>
                    </g>
                  </svg>
                ) : (
                  <svg
                    fill="currentColor"
                    height="16"
                    viewBox="0 0 367.676 367.676"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <g>
                        <path d="m183.837 287.247c-6.095 0-11.939-2.422-16.249-6.731l-160.857-160.859c-8.974-8.975-8.974-23.524 0-32.498 8.975-8.974 23.525-8.973 32.498 0l144.609 144.609 144.609-144.609c8.973-8.974 23.525-8.974 32.498 0 8.974 8.974 8.974 23.524 0 32.498l-160.858 160.859c-4.31 4.309-10.155 6.731-16.25 6.731z"></path>
                      </g>
                    </g>
                  </svg>
                )}
              </button>

              {openNodes[nodeKey] && (
                <div className="px-3 mt-2">
                  {accordionData.get(subCategory.id)?.map((treatment: any) => {
                    const treatmentKey = parentPath
                      ? `${parentPath}-${subCategory.id}-${treatment.Id}`
                      : `${subCategory.id}-${treatment.Id}`;
                    return (
                      <div key={treatmentKey}>
                        <div
                          className={`service-item mb-2 p-2 ${
                            openNodes[treatment.Id] ? "active" : ""
                          }`}
                          // onClick={() => toggleNode(treatmentKey)}
                        >
                          <div className="d-block d-md-flex justify-content-between align-items-start">
                            <div className="treatment_selection_name">
                              <h4>{treatment.TreatmentName}</h4>
                              <div className="small text-muted">
                                <i className="bi bi-currency-yen"></i>
                                {formatNumberWithCommas(
                                  treatment.FeeIncludingTax
                                )}{" "}
                                ·{" "}
                                {formatTimeDisplay(
                                  Number(
                                    getAllTimeOptions?.find(
                                      (time) => time.id === treatment.Time
                                    )?.value ?? 0
                                  )
                                )}
                              </div>
                              <div className="col-12 small text-muted">
                                {treatment.Description}
                              </div>
                            </div>
                            {values.selectedServices.some(
                              (service: any) =>
                                service.TreatmentId == Number(treatment.Id)
                            ) ? (
                              <div className="text-end">
                                <span className="bg-primary text-white py-2 px-2 px-md-4 fs-sm rounded me-2">
                                  <svg
                                    className="me-1"
                                    height="12"
                                    viewBox="0 -65 512 512"
                                    width="12"
                                    fill="currentColor"
                                  >
                                    <path d="m444.175781 0-260.871093 242.011719-110.324219-117.734375-72.980469 68.386718 178.234375 190.207032 333.765625-309.351563zm0 0"></path>
                                  </svg>
                                  <FormattedMessage id="menu_added" />
                                </span>
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-sm"
                                  onClick={(e) => {
                                    toggleNode(treatmentKey);
                                    e.stopPropagation();
                                    handleTreatmentServiceSelect(
                                      Number(treatment.Id)
                                    );
                                  }}
                                >
                                  <svg
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 512 512"
                                    fill="currentColor"
                                    width="18"
                                  >
                                    <g>
                                      <g>
                                        <path
                                          d="M436,60h-75V45c0-24.813-20.187-45-45-45H196c-24.813,0-45,20.187-45,45v15H76c-24.813,0-45,20.187-45,45
          c0,19.928,13.025,36.861,31.005,42.761L88.76,470.736C90.687,493.875,110.385,512,133.604,512h244.792
          c23.22,0,42.918-18.125,44.846-41.271l26.753-322.969C467.975,141.861,481,124.928,481,105C481,80.187,460.813,60,436,60z M181,45
          c0-8.271,6.729-15,15-15h120c8.271,0,15,6.729,15,15v15H181V45z M393.344,468.246c-0.643,7.712-7.208,13.754-14.948,13.754
          H133.604c-7.739,0-14.305-6.042-14.946-13.747L92.294,150h327.412L393.344,468.246z M436,120H76c-8.271,0-15-6.729-15-15
          s6.729-15,15-15h360c8.271,0,15,6.729,15,15S444.271,120,436,120z"
                                        ></path>
                                      </g>
                                    </g>
                                    <g>
                                      <g>
                                        <path
                                          d="M195.971,436.071l-15-242c-0.513-8.269-7.67-14.558-15.899-14.043c-8.269,0.513-14.556,7.631-14.044,15.899l15,242.001
          c0.493,7.953,7.097,14.072,14.957,14.072C189.672,452,196.504,444.684,195.971,436.071z"
                                        ></path>
                                      </g>
                                    </g>
                                    <g>
                                      <g>
                                        <path d="M256,180c-8.284,0-15,6.716-15,15v242c0,8.284,6.716,15,15,15s15-6.716,15-15V195C271,186.716,264.284,180,256,180z"></path>
                                      </g>
                                    </g>
                                    <g>
                                      <g>
                                        <path
                                          d="M346.927,180.029c-8.25-0.513-15.387,5.774-15.899,14.043l-15,242c-0.511,8.268,5.776,15.386,14.044,15.899
          c8.273,0.512,15.387-5.778,15.899-14.043l15-242C361.483,187.659,355.196,180.541,346.927,180.029z"
                                        ></path>
                                      </g>
                                    </g>
                                  </svg>
                                </button>
                              </div>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                onClick={(e) => {
                                  toggleNode(treatmentKey);
                                  e.stopPropagation();
                                  handleTreatmentServiceSelect(
                                    Number(treatment.Id)
                                  );
                                }}
                              >
                                + <FormattedMessage id="add_a_menu" />
                              </button>
                            )}
                          </div>
                        </div>

                        {values?.selectedServices?.some(
                          (service: any) =>
                            service.TreatmentId === Number(treatment.Id)
                        ) &&
                          treatment.optionVm?.length > 0 && (
                            <div className="options-menu mb-3">
                              <h6 className="mb-3">
                                <FormattedMessage id="options_menu" />
                              </h6>
                              {treatment.optionVm?.map(
                                (option: any, index: number) => (
                                  <React.Fragment>
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                      <div className="treatment_selection_name">
                                        <h4>{option.OptionName}</h4>
                                        <div className="small text-muted">
                                          <i className="bi bi-currency-yen"></i>
                                          {formatNumberWithCommas(
                                            option.FeeIncludingTax
                                          )}{" "}
                                          ·{" "}
                                          
                                        </div>
                                      </div>

                                      {values.selectedServices?.some(
                                            (item) =>
                                              item.TreatmentId ===
                                                Number(treatment.Id) &&
                                              item.OptionIds?.includes(
                                                Number(option.OptionId)
                                              )
                                          ) ? (
                                            <button
                                              type="button"
                                              key={option.OptionId}
                                              className="btn btn-primary btn-sm"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleOptionServiceSelect(
                                                  Number(treatment.Id),
                                                  Number(option.OptionId)
                                                );
                                              }}
                                            >
                                              <span>
                                                <i className="bi bi-check-lg me-1"></i>
                                                <FormattedMessage id="options_selected" />
                                              </span>
                                            </button>
                                          ) : ( 
                                            <button
                                              type="button"
                                              key={option.OptionId}
                                              className="btn btn-outline-primary btn-sm"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleOptionServiceSelect(
                                                  Number(treatment.Id),
                                                  Number(option.OptionId)
                                                );
                                              }}
                                            >
                                              <span>
                                                <FormattedMessage id="select_option_menu" />
                                              </span>
                                            </button>
                                          )}
                                    </div>
                                  </React.Fragment>
                                )
                              )}
                            </div>
                          )}
                      </div>
                    );
                  })}
                </div>
              )}

              {subCategory.children &&
                subCategory.children?.length > 0 &&
                renderNestedServices(subCategory.children, nodeKey)}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <div className="service-selection">
        <MenuSelectionSummary selectedServices={values.selectedServices} />
        {/* Error Message */}
        <ErrorMessage
          name="selectedServices"
          component="div"
          className="text-danger mb-2"
        />

        {/* Category Dropdowns */}
        <div className="card mb-2">
          <div className="choose-menu-section mb-4 p-2">
            <h6 className="mb-3">
              <FormattedMessage id="choose_a_menu" />
            </h6>

            {allCategoryBookingManagement?.map((category: any) => {
              if (category.distinction == 1) {
                return (
                  <div key={category.id} className="px-2 px-md-4">
                    <button
                      type="button"
                      className="accordian_btn d-flex justify-content-between align-items-center text-start"
                      onClick={() => {
                        toggleNode(`${category.id}-NCT`);
                        GetTreatmentOptionMenuListByCatIdCustomerService(
                          category.id,
                          null,
                          storeId,
                          storeCodeDetails.BusinessTypeId
                        );
                      }}
                    >
                      {category.title}
                      {openNodes[`${category.id}-NCT`] ? (
                        <svg
                          fill="currentColor"
                          height="16"
                          viewBox="0 0 367.676 367.676"
                          width="16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g>
                            <g>
                              <path d="m344.696 287.246c-5.881 0-11.763-2.243-16.249-6.73l-144.61-144.609-144.608 144.609c-8.973 8.975-23.524 8.975-32.498 0-8.974-8.974-8.974-23.524 0-32.498l160.857-160.859c4.31-4.309 10.154-6.731 16.249-6.731 6.094 0 11.94 2.422 16.25 6.731l160.858 160.858c8.974 8.974 8.974 23.524 0 32.498-4.486 4.488-10.368 6.731-16.249 6.731z"></path>
                            </g>
                          </g>
                        </svg>
                      ) : (
                        <svg
                          fill="currentColor"
                          height="16"
                          viewBox="0 0 367.676 367.676"
                          width="16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g>
                            <g>
                              <path d="m183.837 287.247c-6.095 0-11.939-2.422-16.249-6.731l-160.857-160.859c-8.974-8.975-8.974-23.524 0-32.498 8.975-8.974 23.525-8.973 32.498 0l144.609 144.609 144.609-144.609c8.973-8.974 23.525-8.974 32.498 0 8.974 8.974 8.974 23.524 0 32.498l-160.858 160.859c-4.31 4.309-10.155 6.731-16.25 6.731z"></path>
                            </g>
                          </g>
                        </svg>
                      )}
                    </button>

                    {openNodes[`${category.id}-NCT`] && (
                      <div className="mt-2">
                        {accordionLoading.get(category.id) == true ? (
                          <Skeleton count={5} />
                        ) : (
                          accordionData.get(category.id)?.map((treatment) => {
                            const treatmentKey = category.id
                              ? `${category.id}-NCT-${treatment.Id}`
                              : `${category.id}-${treatment.Id}`;
                            return (
                              <div key={treatmentKey}>
                                <div
                                  className={`service-item p-2 mb-2 ${
                                    openNodes[treatment.Id] ? "active" : ""
                                  } ${
                                    values.selectedServices.some(
                                      (service: any) =>
                                        service.TreatmentId ==
                                        Number(treatment.Id)
                                    )
                                      ? "bg-primary-light"
                                      : ""
                                  } `}
                                  onClick={() => {
                                    // toggleNode(treatmentKey);
                                  }}
                                >
                                  <div className="d-block d-md-flex justify-content-between align-items-start">
                                    <div className="treatment_selection_name">
                                      <h4>{treatment.TreatmentName}</h4>
                                      <div className="small text-muted">
                                        <i className="bi bi-currency-yen"></i>
                                        {formatNumberWithCommas(
                                          treatment.FeeIncludingTax
                                        )}{" "}
                                        ·{" "}
                                        {formatTimeDisplay(
                                          Number(
                                            getAllTimeOptions?.find(
                                              (time) =>
                                                time.id === treatment.Time
                                            )?.value ?? 0
                                          )
                                        )}{" "}
                                      </div>
                                      <div className="small text-muted col-12">
                                        {treatment.Description}
                                      </div>
                                    </div>

                                    {values.selectedServices.some(
                                      (service: any) =>
                                        service.TreatmentId ==
                                        Number(treatment.Id)
                                    ) ? (
                                      <div className="text-end">
                                        <span className="bg-primary text-white py-2 px-2 px-md-4 fs-sm rounded me-2">
                                          <svg
                                            className="me-1"
                                            height="12"
                                            viewBox="0 -65 512 512"
                                            width="12"
                                            fill="currentColor"
                                          >
                                            <path d="m444.175781 0-260.871093 242.011719-110.324219-117.734375-72.980469 68.386718 178.234375 190.207032 333.765625-309.351563zm0 0"></path>
                                          </svg>
                                          <FormattedMessage id="menu_added" />
                                        </span>
                                        <button
                                          type="button"
                                          className="btn btn-outline-danger btn-sm"
                                          onClick={(e) => {
                                            toggleNode(treatmentKey);
                                            e.stopPropagation();
                                            handleTreatmentServiceSelect(
                                              Number(treatment.Id)
                                            );
                                          }}
                                        >
                                          <svg
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 512 512"
                                            fill="currentColor"
                                            width="18"
                                          >
                                            <g>
                                              <g>
                                                <path
                                                  d="M436,60h-75V45c0-24.813-20.187-45-45-45H196c-24.813,0-45,20.187-45,45v15H76c-24.813,0-45,20.187-45,45
          c0,19.928,13.025,36.861,31.005,42.761L88.76,470.736C90.687,493.875,110.385,512,133.604,512h244.792
          c23.22,0,42.918-18.125,44.846-41.271l26.753-322.969C467.975,141.861,481,124.928,481,105C481,80.187,460.813,60,436,60z M181,45
          c0-8.271,6.729-15,15-15h120c8.271,0,15,6.729,15,15v15H181V45z M393.344,468.246c-0.643,7.712-7.208,13.754-14.948,13.754
          H133.604c-7.739,0-14.305-6.042-14.946-13.747L92.294,150h327.412L393.344,468.246z M436,120H76c-8.271,0-15-6.729-15-15
          s6.729-15,15-15h360c8.271,0,15,6.729,15,15S444.271,120,436,120z"
                                                ></path>
                                              </g>
                                            </g>
                                            <g>
                                              <g>
                                                <path
                                                  d="M195.971,436.071l-15-242c-0.513-8.269-7.67-14.558-15.899-14.043c-8.269,0.513-14.556,7.631-14.044,15.899l15,242.001
          c0.493,7.953,7.097,14.072,14.957,14.072C189.672,452,196.504,444.684,195.971,436.071z"
                                                ></path>
                                              </g>
                                            </g>
                                            <g>
                                              <g>
                                                <path d="M256,180c-8.284,0-15,6.716-15,15v242c0,8.284,6.716,15,15,15s15-6.716,15-15V195C271,186.716,264.284,180,256,180z"></path>
                                              </g>
                                            </g>
                                            <g>
                                              <g>
                                                <path
                                                  d="M346.927,180.029c-8.25-0.513-15.387,5.774-15.899,14.043l-15,242c-0.511,8.268,5.776,15.386,14.044,15.899
          c8.273,0.512,15.387-5.778,15.899-14.043l15-242C361.483,187.659,355.196,180.541,346.927,180.029z"
                                                ></path>
                                              </g>
                                            </g>
                                          </svg>
                                        </button>
                                      </div>
                                    ) : (
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={(e) => {
                                          toggleNode(treatmentKey);
                                          e.stopPropagation();
                                          handleTreatmentServiceSelect(
                                            Number(treatment.Id)
                                          );
                                        }}
                                      >
                                        + <FormattedMessage id="add_a_menu" />
                                      </button>
                                    )}
                                  </div>
                                </div>

                                {values?.selectedServices?.some(
                                  (service: any) =>
                                    service.TreatmentId === Number(treatment.Id)
                                ) &&
                                  treatment.optionVm?.length > 0 && (
                                    <div className="options-menu mb-3">
                                      <h6 className="mb-3">
                                        <FormattedMessage id="options_menu" />
                                      </h6>
                                      {treatment.optionVm?.map(
                                        (option: any, index: number) => (
                                          <React.Fragment>
                                            <div className="d-flex justify-content-between align-items-start px-3 mb-3">
                                              <div className="treatment_selection_name">
                                        <h4>{option.OptionName}</h4>
                                        <div className="small text-muted">
                                          <i className="bi bi-currency-yen"></i>
                                          {formatNumberWithCommas(
                                            option.FeeIncludingTax
                                          )}{" "}
                                          
                                        </div>
                                      </div>                                             
                                              {values.selectedServices?.some(
                                                    (item: any) =>
                                                      item.TreatmentId ===
                                                        Number(
                                                          treatment.Id
                                                        ) &&
                                                      item.OptionIds?.includes(
                                                        Number(
                                                          option.OptionId
                                                        )
                                                      )
                                                  ) ? (
                                            <button
                                              type="button"
                                              key={option.OptionId}
                                              className="btn btn-primary btn-sm"
                                              onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleOptionServiceSelect(
                                                    Number(treatment.Id),
                                                    Number(option.OptionId)
                                                  );
                                                }}
                                            >
                                              <span>
                                                <i className="bi bi-check-lg me-1"></i>
                                                <FormattedMessage id="options_selected" />
                                              </span>
                                            </button>
                                          ) : (
                                            <button
                                              type="button"
                                              key={option.OptionId}
                                              className="btn btn-outline-primary btn-sm"
                                              onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleOptionServiceSelect(
                                                    Number(treatment.Id),
                                                    Number(option.OptionId)
                                                  );
                                                }}
                                            >
                                              <span>
                                                <FormattedMessage id="select_option_menu" />
                                              </span>
                                            </button>
                                          )}
                                            </div>
                                          </React.Fragment>
                                        )
                                      )}
                                    </div>
                                  )}
                              </div>
                            );
                          })
                        )}
                      </div>
                    )}

                    {/* Render nested children for this category */}
                    {openNodes[`${category.id}-NCT`] &&
                      category.children &&
                      renderNestedServices(category.children, category.id)}
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    </>
  );
});

const SelectedMenuData: React.FC<{key:number;data:any;}> = observer(({key,data}) => {
  const { values } = useFormikContext<BookingFormValues>();
  const { bookingManagementStore, masterManagementStore } = useStore();
  const { getAllTimeOptions } = masterManagementStore;
  const { accordionData } = bookingManagementStore;

  const getAccordionDataById = (id: number) => {
    let result: any = null;
    accordionData.forEach((items, categoryId) => {
      if (!result) {
        const foundItem = items.find((item: { Id: number }) => item.Id === id);
        if (foundItem) {
          result = foundItem;
        }
      }
    });
    return result;
  };

  let treatmentData: any = getAccordionDataById(data?.TreatmentId);
  return (
    <React.Fragment>
                <div className="row g-0 treatment_wrap">
                  <div
                    key={treatmentData?.Id}
                    className="col-sm-7 col-6 treatment_value"
                  >
                    <p className="treatment_name">
                      {treatmentData?.TreatmentName ?? ""}
                    </p>
                    <p className="text-muted small mb-0">
                      {treatmentData?.Description ?? ""}
                    </p>
                  </div>
                  {/* {JSON.stringify(treatmentData?.FeeIncludingTax)} */}
                  <div className="col-sm-2 col-3 fee_value" key={key+"Fee"+treatmentData?.Id}>
                    <i className="bi bi-currency-yen"></i>
                    {formatNumberWithCommas(treatmentData?.FeeIncludingTax)}
                  </div>
                  <div className="col-3 time_value" key={key+"Time"+treatmentData?.Id}>
                    {getAllTimeOptions?.find(
                      (time) => time.id === (treatmentData?.Time ?? 0)
                    )
                      ? formatTimeDisplay(
                          Number(
                            getAllTimeOptions?.find(
                              (time) => time?.id === (treatmentData?.Time ?? 0)
                            )?.value ?? 0
                          )
                        )
                      : 0}{" "}
                  </div>
                </div>

                <div className="option_menu">
                  {data?.OptionIds?.map((optionId: number) => {
                    const option =
                      treatmentData?.optionVm?.length > 0
                        ? treatmentData?.optionVm?.find(
                            (op: any) => op.OptionId == optionId
                          )
                        : null;
                    return (
                      option && (
                        <div className="row g-0">
                          <div className="col-sm-7 col-6 treatment_value">
                            <p className="treatment_name">
                              {option.OptionName}
                            </p>
                            <p className="text-muted small mb-0">
                              {option.Description}
                            </p>
                          </div>

                          <div
                            key={data.TreatmentId}
                            className="col-sm-2 col-3 fee_value"
                          >
                            <i className="bi bi-currency-yen"></i>{" "}
                            {formatNumberWithCommas(option.FeeIncludingTax)}
                          </div>

                          <div
                            key={data.TreatmentId}
                            className="time_value col-3"
                          >
                            {formatTimeDisplay(Number(option.TimeValue ?? 0))}{" "}
                          </div>
                        </div>
                      )
                    );
                  })}
                </div>
              
    </React.Fragment>
  );
});

const StaffSelection: React.FC<{
  formikProps: FormikProps<BookingFormValues>;
  storeId: number;
}> = observer(({ formikProps, storeId }) => {
  const { values, setFieldValue, validateField, setFieldError } = formikProps;
  const { masterManagementStore, bookingManagementStore } = useStore();

  const {
    GetAllStaffOptionServiceByStoreIdBooking,
    getAllStaffOptionsForBooking,
  } = masterManagementStore;
  const { getAccordionDataById } = bookingManagementStore;
  const handleStaffSelect = (staffId: number) => {
    setFieldValue("selectedStaff", staffId, false);
    
    setFieldValue(
      "isTreatmentInvalidByStaff",
      isAnyTreatmentInvalidByStaff(
        values?.selectedServices,
        staffId,
        getAccordionDataById
      ),false
    );
    
    setFieldValue("selectedDate", null, false);
    setFieldError("selectedDate", "");
    //Here we will get the shift of the Staff on the basis of the StaffId & will block those dates on the Calendar
  };

  useEffect(() => {
    GetAllStaffOptionServiceByStoreIdBooking(storeId);
  }, []);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 12,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 3100,
        settings: {
          slidesToShow: 10,
        },
      },
      {
        breakpoint: 2800,
        settings: {
          slidesToShow: 9,
        },
      },
      {
        breakpoint: 2560,
        settings: {
          slidesToShow: 8,
        },
      },
      {
        breakpoint: 2200,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },

      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 250,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  
  const staffSectionRef = useRef<HTMLDivElement>(null);
  const [staffStickyVisible, setStaffStickyVisible] = useState(false);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setStaffStickyVisible(!entry.isIntersecting),
      {
        root: null, // viewport
        threshold: 0, // 100% of the target is visible
      }
    );
    if (staffSectionRef.current) {
      observer.observe(staffSectionRef.current);
    }
    return () => observer.disconnect();
  }, []);

  function StaffDropdown({ staffList, selectedId, onSelect }: any) {
  const selectedStaff = staffList.find((staff: any) => staff.Id === selectedId);

  return (
    <div className="dropdown staff-sticky-dropdown position-relative me-2">
      <button
        className="btn btn-light dropdown-toggle d-flex align-items-center"
        type="button"
        id="staffDropdownButton"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <img
          src={selectedStaff?.Image || demoStoreIcon}
          alt={selectedStaff?.Name}
          className="dropdown-profile-img"
        />
        <span>{selectedStaff?.Name || "Select Staff"}</span>
        {selectedStaff?.IsNominationFee && (
          <span className="dropdown-nomination-fee ms-3">
            <i className="bi bi-currency-yen me-1"></i>
            {formatNumberWithCommas(selectedStaff.NominationFee)}
          </span>
        )}
      </button>

      <ul className="dropdown-menu w-100" aria-labelledby="staffDropdownButton" style={{ minWidth: 220 }}>
        {staffList.map((staff: any) => (
          <li key={staff.Id}>
            <button
              type="button"
              className={`dropdown-item d-flex align-items-center ${
                staff.Id === selectedId ? "active" : ""
              }`}
              onClick={() => onSelect(staff.Id)}
            >
              <img
                src={staff.Image || demoStoreIcon}
                alt={staff.Name}
                className="dropdown-profile-img"
              />
              <span>{staff.Name}</span>
              {staff.IsNominationFee && (
                <span className="dropdown-nomination-fee">
                  <i className="bi bi-currency-yen me-1"></i>
                  {formatNumberWithCommas(staff.NominationFee)}
                </span>
              )}
              {staff.Id === selectedId && (
                <i className="bi bi-check2 ms-auto text-primary" />
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

  return (
    <div className="staff-section">
      {staffStickyVisible && (
        <StaffDropdown
          staffList={getAllStaffOptionsForBooking}
          selectedId={formikProps.values.selectedStaff}
          onSelect={(id: any) => {
            setFieldValue("selectedDate", null);
            setFieldValue("selectedStaff", id);

            setFieldValue(
              "isTreatmentInvalidByStaff",
              isAnyTreatmentInvalidByStaff(
                values?.selectedServices,
                id,
                getAccordionDataById
              )
            );
          }}
        />
      )}
      <MenuSelectionSummary selectedServices={values.selectedServices} />
      <div className=" card card-body  mt-3">
        <h6 className="section-title pb-0 m-0" ref={staffSectionRef}>
          <FormattedMessage id="select_a_staff" />
        </h6>
        <ErrorMessage
          name="selectedStaff"
          component="div"
          className="text-danger mb-2"
        />

        <Slider {...settings} className="staff-list">
          {getAllStaffOptionsForBooking.map((person) => (
            <div
              key={person.Id}
              className={`staff-item text-center ${
                values.selectedStaff === person.Id ? "selected" : ""
              }`}
              onClick={() => handleStaffSelect(person.Id)}
            >
              <div className="staff-photo mb-2">
                <img
                  src={person.Image ? person.Image : demoStoreIcon}
                  alt={person.Name}
                />
              </div>
              <div className="staff-name">{person.Name}</div>
              <div className="d-flex align-items-center justify-content-around small text-muted">
                {person.Expertise && <span>{person.Expertise}</span>}
                <span>
                  {person.IsNominationFee && (
                    <>
                      <i className="bi bi-currency-yen"></i>
                      {formatNumberWithCommas(person.NominationFee)}
                    </>
                  )}
                </span>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
});

const Calendar: React.FC<{
  formikProps: FormikProps<BookingFormValues>;
  storeId: number;
}> = observer(({ formikProps, storeId }) => {
  const { values, setFieldValue } = formikProps;

  const {
    masterManagementStore,
    bookingManagementStore,
    reservationSchedulerStore,
    storeCmsStore,
  } = useStore();

  const { cmsStoreDetails } = storeCmsStore;

  const {
    getReservationSettingDetail,
    getReservationSettingMinMaxDetail,
    staffOptionsState,
    getAllTimeOptions,
  } = masterManagementStore;

  const {
    GetAllStaffOptionServiceByStoreIdBooking,
    getAllStaffOptionsForBooking,
  } = masterManagementStore;
  const {
    GetNoOfAvailabilityServiceDatesBlock,
    staffShiftScheduleState,
    blockedAppointmentState,
    GetTheDateTimeSlotsMappingService,
    mapCalendarSlots,
    mapSlotState,
    getAccordionDataById,
  } = bookingManagementStore;
  const [minuteInterval, setMinuteInterval] = useState(
    getReservationSettingDetail.CalendarIntervalTime
  );
  const minuteSteps = [5, 10, 15, 20, 30];
  const hours =
    generateWeeklyHours(getReservationSettingMinMaxDetail).length - 1;
  const [currentDate, setCurrentDate] = useState(new Date()); // Track current month and year
  const openTime = getOpenTimeFromReservationSettingForCustomerSide(
    getReservationSettingMinMaxDetail
  );

  const [daysToShow, setDaysToShow] = useState(
    window.innerWidth < 768 ? 7 : 14
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 767px)");

    const handleChange = (e: MediaQueryListEvent) => {
      setDaysToShow(e.matches ? 7 : 14);
    };

    // Set initial value
    setDaysToShow(mediaQuery.matches ? 7 : 14);

    // Attach listener
    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  const generateTimeSlots = (
    openTime: string,
    totalHours: number,
    minuteInterval: number
  ): string[] => {
    const slots: string[] = [];
    const start = moment(openTime, "HH:mm");
    const totalMinutes = totalHours * 60;

    for (let i = 0; i <= totalMinutes; i += minuteInterval) {
      slots.push(
        start.clone().startOf("hour").add(i, "minutes").format("HH:mm")
      );
    }

    return slots;
  };

  const timeSlots = generateTimeSlots(
    openTime,
    hours,
    minuteSteps[minuteInterval]
  );

  const goToNextWeek = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + 7);
      return newDate;
    });
  };

  // Function to navigate to the previous month
  const goToPreviousWeek = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() - 7);
      return newDate;
    });
  };

  const getDayIsClosed = (day: any) => {
    if (getReservationSettingDetail?.BusinessSettings?.length > 0) {
      let dayData = getReservationSettingDetail?.BusinessSettings?.find(
        (data: any) => data.WeekDays == day
      );
      return dayData.IsClosed;
    }
    return false;
  };

  const getDayHolidayIsClosed = (currentDateStr: any) => {
    const currentDate = moment(currentDateStr);
    const formattedDate = moment(currentDate).format("YYYY-MM-DD");
    const isItInHoliday = JapaneseHolidays?.some((holiday: any) => {
      return moment(holiday.date).format("YYYY-MM-DD") === formattedDate;
    });
    if (getReservationSettingDetail?.IsHoliday == true) {
      if (isItInHoliday) {
        return true;
      }
    }
    return false;
  };

  // Function to generate an array of dates for the current month
  const generateDates = () => {
    const dates = [];
    for (let i = 0; i < daysToShow; i++) {
      const nextDay = new Date(currentDate);
      nextDay.setDate(currentDate.getDate() + i);
      dates.push(nextDay);
    }
    return dates;
  };

  const generatedDates = generateDates();

  const groupDatesByMonthWithZeros = () => {
    const dates = generatedDates;
    if (dates.length === 0) return [];

    // Get first and last month/year values
    const first = dates[0];
    const last = dates[dates.length - 1];
    const result: { month: string; count: number }[] = [];

    // Generate all months between first and last (inclusive)
    let year = first.getFullYear();
    let month = first.getMonth();

    const monthCounts: Record<string, number> = {};

    while (
      year < last.getFullYear() ||
      (year === last.getFullYear() && month <= last.getMonth())
    ) {
      const monthName = new Date(year, month).toLocaleString("default", {
        month: "short",
      });
      monthCounts[monthName] = 0;
      month++;
      if (month > 11) {
        month = 0;
        year++;
      }
    }

    // Count dates per month
    dates.forEach((date: any) => {
      const monthName = date.toLocaleString("default", { month: "short" });
      monthCounts[monthName]++;
    });

    // Turn the map into an array of objects
    for (const monthName in monthCounts) {
      result.push({
        month: formatMessage(monthName),
        count: monthCounts[monthName],
      });
    }
    return result;
  };

  const groupedMonths = groupDatesByMonthWithZeros();

  const handleDateSelect = (dateTime: any) => {
    if (
      isAnyTreatmentInvalidByDate(
        values?.selectedServices,
        dateTime,
        getAccordionDataById
      )
    ) {
      toast.error(formatMessage("expired_treatment"));
    } else {
      setFieldValue("selectedDate", dateTime);
    }
  };

  const calculateTotals = () => {
    let fee = 0;
    let time = 0;
    let optionTime = 0;
    let optionFee = 0;
    values.selectedServices?.map((service: any) => {
      const treatmentData = getAccordionDataById(Number(service.TreatmentId));
      const getTreatmentTime = getAllTimeOptions?.find(
        (time) => time.id == (treatmentData?.Time ?? 0)
      )
        ? Number(
            getAllTimeOptions?.find(
              (time) => time.id == (treatmentData?.Time ?? 0)
            )?.value
          )
        : 0;

      service.OptionIds?.map((ids: number) => {
        const option =
          treatmentData?.optionVm?.length > 0
            ? treatmentData?.optionVm?.find((op: any) => op.OptionId == ids)
            : null;
        if (option) {
          optionTime += option?.TimeValue;
          optionFee += option?.FeeIncludingTax;
        }
      });
      fee += treatmentData?.FeeIncludingTax;
      time += getTreatmentTime;
    });
    return { FeeIncludingTax: fee + optionFee, Time: time + optionTime };
  };

  useEffect(() => {
    let selectedServicesIds: number[] = [];
    if (values?.selectedServices?.length > 0) {
      values.selectedServices?.map((service: any) => {
        selectedServicesIds.push(service.TreatmentId);
      });
    }
    if (Number(values.selectedStaff == -2)) {
      GetTheDateTimeSlotsMappingService(
        "",
        storeId,
        moment(currentDate)?.format("YYYY-MM-DD"),
        moment(currentDate)?.add(2, "week")?.format("YYYY-MM-DD"),
        1,
        minuteSteps[minuteInterval] == undefined
          ? minuteSteps[0]
          : minuteSteps[minuteInterval],
        Number(calculateTotals().Time ?? 0),
        selectedServicesIds
      );
    } else if (Number(values.selectedStaff == -1)) {
      GetTheDateTimeSlotsMappingService(
        "",
        storeId,
        moment(currentDate)?.format("YYYY-MM-DD"),
        moment(currentDate)?.add(2, "week")?.format("YYYY-MM-DD"),
        0,
        minuteSteps[minuteInterval] == undefined
          ? minuteSteps[0]
          : minuteSteps[minuteInterval],
        Number(calculateTotals().Time ?? 0),
        selectedServicesIds
      );
    } else if (Number(values.selectedStaff > 0)) {
      GetNoOfAvailabilityServiceDatesBlock(
        Number(values.selectedStaff),
        storeId,
        moment(currentDate)?.format("YYYY-MM-DD"),
        moment(currentDate)?.add(2, "week")?.format("YYYY-MM-DD")
      );
      GetTheDateTimeSlotsMappingService(
        Number(values.selectedStaff),
        storeId,
        moment(currentDate)?.format("YYYY-MM-DD"),
        moment(currentDate)?.add(2, "week")?.format("YYYY-MM-DD"),
        "",
        minuteSteps[minuteInterval] == undefined
          ? minuteSteps[0]
          : minuteSteps[minuteInterval],
        Number(calculateTotals().Time ?? 0),
        selectedServicesIds
      );
    } else if (Number(values.selectedStaff == -3)) {
      GetTheDateTimeSlotsMappingService(
        "",
        storeId,
        moment(currentDate)?.format("YYYY-MM-DD"),
        moment(currentDate)?.add(2, "week")?.format("YYYY-MM-DD"),
        "",
        minuteSteps[minuteInterval] == undefined
          ? minuteSteps[0]
          : minuteSteps[minuteInterval],
        Number(calculateTotals().Time ?? 0),
        selectedServicesIds
      );
    }
  }, [values.selectedStaff, currentDate, minuteInterval]);

const calendarRef = useRef<HTMLDivElement>(null);
const [calendarSticky, setCalendarSticky] = useState(false);

useEffect(() => {
  const el = calendarRef.current;
  if (!el) return;

  let ticking = false;

  const checkSticky = () => {
    const rect = el.getBoundingClientRect();
    // sticky when the top of calendar reaches/passes the viewport top
    // AND some part of the calendar is still visible (bottom > 0)
    const shouldBeSticky = rect.top <= 0 && rect.bottom > 0;
    setCalendarSticky(prev => (prev === shouldBeSticky ? prev : shouldBeSticky));
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        checkSticky();
        ticking = false;
      });
      ticking = true;
    }
  };

  // initial check (handles reload at a scrolled position)
  checkSticky();

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);

  return () => {
    window.removeEventListener("scroll", onScroll);
    window.removeEventListener("resize", onScroll);
  };
}, []);


  return (
    <>
      {(staffShiftScheduleState.inProgress ||
        staffOptionsState.inProgress ||
        mapSlotState.inProgress ||
        blockedAppointmentState.inProgress) && (
        <FormLoader
          loading={
            staffShiftScheduleState.inProgress ||
            blockedAppointmentState.inProgress ||
            staffOptionsState.inProgress ||
            mapSlotState.inProgress
          }
        />
      )} 
 
      <div ref={calendarRef} className={`calendar-section card card-body mt-3 mb-4 ${calendarSticky ? "calendar-sticky-active" : ""}`} >
        <div className="calendar-header d-flex justify-content-between align-items-center mb-3">
          {moment(currentDate).isSame(new Date(), "week") ? (
            <></>
          ) : (
            <button
              type="button"
              className="btn btn-link text-decoration-none ps-0"
              onClick={goToPreviousWeek}
            >
              <svg
                className="me-1 me-md-3"
                id="fi_2609370"
                height="24"
                viewBox="0 0 32 32"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                data-name="Layer 2"
              >
                <path d="m16 1a15 15 0 1 0 15 15 15.017 15.017 0 0 0 -15-15zm2.707 20.293a1 1 0 1 1 -1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 1.414l-5.293 5.293z"></path>
              </svg>
              <span className="d-none d-sm-inline">
                <FormattedMessage id="previous_week" />
              </span>
            </button>
          )}

          <h4 className="month_name">
            {currentDate?.getFullYear()}
            <FormattedMessage id="label_year" />{" "}
            {groupedMonths[0]?.count > 0 && groupedMonths[0]?.month}{" "}
            {groupedMonths[1]?.count > 0 && " - " + groupedMonths[1]?.month}{" "}
          </h4>
          <div className="d-flex align-items-center justify-content-end">
            {/* <select
              className="form-select"
              value={minuteInterval}
              disabled={true}
              onChange={(e) => {
                setMinuteInterval(Number(e.target.value));
              }}
            >
              {minuteSteps.map((step, index) => (
                <option key={index} value={index}>
                  {step} <FormattedMessage id="min" />
                </option>
              ))}
            </select> */}
            <button
              type="button"
              className="btn btn-link text-decoration-none pe-0"
              onClick={goToNextWeek}
            >
              <span className="d-none d-sm-inline">
                <FormattedMessage id="next_week" />
              </span>
              <svg
                className="ms-1 ms-md-3"
                id="fi_2609367"
                height="24"
                viewBox="0 0 32 32"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                data-name="Layer 2"
              >
                <path d="m16 1a15 15 0 1 0 15 15 15.017 15.017 0 0 0 -15-15zm4.707 15.707-6 6a1 1 0 0 1 -1.414-1.414l5.293-5.293-5.293-5.293a1 1 0 0 1 1.414-1.414l6 6a1 1 0 0 1 0 1.414z"></path>
              </svg>
            </button>
          </div>
        </div>
        <div className="calendar-grid overflow-x-auto border">
          {/* {JSON.stringify(values.selectedServices)} */}
          <table className="calendarTable">
            <tbody>
              <tr>
                <td className=""></td>
                {groupedMonths[0]?.count && (
                  <td
                    className="month1 p-2 text-center border-end"
                    colSpan={groupedMonths[0]?.count}
                  >
                    {groupedMonths[0]?.month}
                  </td>
                )}
                {groupedMonths[1]?.count && (
                  <td
                    className="month2 p-2 text-center"
                    colSpan={groupedMonths[1]?.count}
                  >
                    {groupedMonths[1]?.month}
                  </td>
                )}
              </tr>
              <tr>
                <td className="dayTd"></td>
                {generatedDates?.map((date: any, i: number) => (
                  <td
                    key={i}
                    className={`border-bottom align-top border-start text-center dayTd ${
                      IsStoreClosedByDateForShift(getReservationSettingDetail,date) == true
                        ? "text-dark bg-black-light"
                        : date.getDay() === weekdayShortEnum.Sat
                        ? "text-info bg-info-light"
                        : date.getDay() === weekdayShortEnum.Sun ||
                          IsStoreClosedByDateBookingCalendar(
                            getReservationSettingDetail,
                            moment(date).format("YYYY-MM-DD")
                          ) === true
                        ? "text-danger bg-danger-light"
                        : ""
                    }`}
                  >
                    <div className={`py-3 `}>
                      {date.getDate()}{" "}
                      <p
                        className={`weekday ${
                          date.getDay() === weekdayShortEnum.Sat
                            ? "text-info"
                            : date.getDay() === weekdayShortEnum.Sun ||
                              IsStoreClosedByDateBookingCalendar(
                                getReservationSettingDetail,
                                moment(date).format("YYYY-MM-DD")
                              ) === true
                            ? "text-danger"
                            : getDayIsClosed(date.getDay()) == true
                            ? "text-dark"
                            : ""
                        }`}
                      >
                        {/* <span>{formatMonth(date)}</span>
                        <br></br> */}
                        {formatMessage(weekdayShortEnum[date.getDay()])}
                      </p>
                      {IsStoreClosedByDateForShift(getReservationSettingDetail,date) == true && (
                        <p className="weekdayClosed">
                          ({formatMessage("closed")})
                        </p>
                      )}
                      {IsStoreClosedByDateBookingCalendar(
                        getReservationSettingDetail,
                        moment(date).format("YYYY-MM-DD")
                      ) === true && (
                        <p className="weekdayClosed text-danger">
                          ({formatMessage("calender_holiday")})
                        </p>
                      )}
                    </div>
                  </td>
                ))}
              </tr>
              {timeSlots?.map((time, i) => (
                <tr key={i}>
                  <td className="text-center border-bottom dayTd">
                    <div className="px-2">{time}</div>
                  </td>
                  {generatedDates.map((date: any, i: number) => {
                    let isDateExists = (mapCalendarSlots ?? []).some(
                      (slots: any) => {
                        return slots.Date == moment(date).format("YYYY-MM-DD");
                      }
                    );

                    let isTimeSlotExists = (mapCalendarSlots ?? []).some(
                      (slots: any) => {
                        if (slots.Date === moment(date).format("YYYY-MM-DD")) {
                          return slots?.TimeSlots?.some(
                            (timeS: any) => timeS == `${time}:00`
                          );
                        } else {
                          return false;
                        }
                      }
                    );

                    let dayIsToday = moment(date).isSame(new Date(), "day");

                    let result = isTimeSlotWithinWindow(
                          getReservationSettingDetail.NewReservationTime,
                          time,
                          moment(date).format("YYYY-MM-DD")
                        );

                    let isCustomerBlockedForThisStore: boolean = false;
                    if (
                      getTokenFromLocalStorage() !== "" &&
                      getUserTypeFromLocalStorage() == "Customer"
                    ) {
                      if (
                        getBlockedStoreIdsCustomerFromLocalStorage()?.length > 0
                      ) {
                        let isBlockedSelectedStore =
                          getBlockedStoreIdsCustomerFromLocalStorage()?.some(
                            (item: number) => item == storeId
                          );
                        if (isBlockedSelectedStore) {
                          isCustomerBlockedForThisStore = true;
                        }
                      }
                    }

                    let isSlotTrue =
                      isDateExists &&
                      isTimeSlotExists &&
                      !isCustomerBlockedForThisStore;

                    let isSlotReallyTrue = false;
                    if (isSlotTrue == true) {
                      if (values.selectedStaff == -3) {
                        isSlotReallyTrue = true;
                      } else {
                        isSlotReallyTrue = values.isTreatmentInvalidByStaff;
                      }
                    }

                    const isSelected =
                      values.selectedDate === `${date} / ${time}`;

                    return (
                      <td
                        className={`border-bottom border-start`}
                      >
                        {/* {JSON.stringify(values.isTreatmentInvalidByStaff)} */}
                        {isSlotTrue == true && isSlotReallyTrue == true ? (
                          result ? (
                            <React.Fragment>
                              <button
                                type="button"
                                key={i}
                                disabled
                                className={`w-100 calendar-btn bg-white not-allowed  ${isDateExists} ${isTimeSlotExists}`}
                              >
                                {/* <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="currentColor"
                                  className="bi bi-telephone-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                                  />
                                </svg> */}
                                T E L
                              </button>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <button
                                type="button"
                                key={i}
                                className={`w-100 calendar-btn ${
                                  isSelected ? "selected" : "allowed"
                                } ${isDateExists} ${isTimeSlotExists}`}
                                onClick={() =>
                                  handleDateSelect(`${date} / ${time}`)
                                }
                              >
                                <svg
                                  version="1.1"
                                  viewBox="0 0 341.333 341.333"
                                  fill="currentColor"
                                >
                                  <g>
                                    <path
                                      d="M170.667,0C76.41,0,0,76.41,0,170.667s76.41,170.667,170.667,170.667s170.667-76.41,170.667-170.667S264.923,0,170.667,0z
                M170.667,298.667c-70.692,0-128-57.308-128-128s57.308-128,128-128s128,57.308,128,128S241.359,298.667,170.667,298.667z"
                                    />
                                  </g>
                                </svg>
                                {/* {JSON.stringify(time)} */}
                              </button>
                            </React.Fragment>
                          )
                        ) : (
                          <React.Fragment>
                            <button
                              type="button"
                              key={i}
                              disabled
                              className={`w-100 calendar-btn not-allowed ${isDateExists} ${isTimeSlotExists} `}
                            >
                              <svg
                                fill="currentColor"
                                viewBox="0 0 320.591 320.591"
                              >
                                <g id="close_1_">
                                  <path
                                    d="M30.391 318.583c-7.86.457-15.59-2.156-21.56-7.288-11.774-11.844-11.774-30.973 0-42.817l257.812-257.813
                c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.207 311.295c-5.893 5.058-13.499
                7.666-21.256 7.288z"
                                  />
                                  <path
                                    d="M287.9 318.583c-7.966-.034-15.601-3.196-21.257-8.806L8.83 52.963C-2.078 40.225-.595 21.055 12.143 10.146
                c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414
                1.414-6.35 5.522-14.707 8.161-23.078 7.288z"
                                  />
                                </g>
                              </svg>
                            </button>
                          </React.Fragment>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* {JSON.stringify(cmsStoreDetails)} */}
        {cmsStoreDetails?.PhoneMessageVisible && (
          <div className="phone-message mt-3 text-left">
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              fill="currentColor"
              className="bi bi-telephone me-2"
              viewBox="0 0 16 16"
            >
              <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
            </svg> */}
            {cmsStoreDetails?.StorePhoneMessage}
          </div>
        )}
        <ErrorMessage
          name="selectedDate"
          component="div"
          className="text-danger mb-2 selectedDateError"
        />
      </div>
    </>
  );
});

const ConfirmationDetails: React.FC<{
  formikProps: FormikProps<BookingFormValues>;
  storeDetails: any;
}> = observer(({ formikProps, storeDetails }) => {
  const { values, setFieldValue } = formikProps;
  const { bookingManagementStore, masterManagementStore, headquarterStore } =
    useStore();
  const { getAllTimeOptions, getAllTaxOptions, getReservationSettingDetail, consumptioTaxSetting } =
    masterManagementStore;
  const { headquarterCancelationPolicyDetails } = headquarterStore;
  const { accordionData, getAccordionDataById } = bookingManagementStore;

  // Format selected services for display
  const selectedServicesInfo = values.selectedServices?.map((service) => {
    const TreatmentData = getAccordionDataById(Number(service.TreatmentId));

    // Return null if TreatmentData is not available
    if (!TreatmentData) {
      return null;
    }

    // Now it's safe to use TreatmentData.Time
    const timeOption = getAllTimeOptions?.find(
      (time) => time.id === TreatmentData.Time
    );
    const getTime = timeOption?.value ? Number(timeOption.value) : 0;

    return {
      Name: TreatmentData.TreatmentName,
      FeeExcludingTax: TreatmentData.FeeExcludingTax,
      FeeIncludingTax: TreatmentData.FeeIncludingTax,
      Tax: TreatmentData.TaxId,
      TaxAmount: TreatmentData.TaxAmount,
      Time: getTime,
      TreatmentData: TreatmentData,
      OptionIds: service.OptionIds,
    };
  });

  const { getAllStaffOptionsForBooking } = masterManagementStore;
  // Get staff info
  const selectedStaffInfo = getAllStaffOptionsForBooking.find(
    (s) => s.Id === values.selectedStaff
  );

  // Calculate total amount
  const totalAmount = () => {
    let totalFee = 0;
    selectedServicesInfo?.map((service) => {
      totalFee += service?.FeeIncludingTax;
      service?.OptionIds?.map((optionId: any) => {
        const option =
          service?.TreatmentData?.optionVm?.length > 0
            ? service.TreatmentData?.optionVm?.find(
                (op: any) => op.OptionId == optionId
              )
            : null;
        totalFee += option.FeeIncludingTax;
      });
    });
    return totalFee;
  };

  const totalTaxAmount = () => {
    let totalTax = 0;
    selectedServicesInfo?.map((service) => {
      totalTax += service?.TaxAmount;
      service?.OptionIds?.map((optionId: any) => {
        const option =
          service?.TreatmentData?.optionVm?.length > 0
            ? service.TreatmentData?.optionVm?.find(
                (op: any) => op.OptionId == optionId
              )
            : null;
        totalTax += option.TaxAmount;
      });
    });
    return totalTax;
  };

  // Calculate total duration
  const totalDuration = () => {
    let totalTime = 0;
    selectedServicesInfo?.map((service) => {
      totalTime += service?.Time ? service.Time : 0;
      service?.OptionIds?.map((optionId: any) => {
        const option =
          service?.TreatmentData?.optionVm?.length > 0
            ? service.TreatmentData?.optionVm?.find(
                (op: any) => op.OptionId == optionId
              )
            : null;
        totalTime += option.TimeValue;
      });
    });
    return totalTime;
  };

  const getTaxRate = () => {
    return typeof consumptioTaxSetting.TaxValue === "string"
      ? parseInt(consumptioTaxSetting?.TaxValue ?? 0)
      : consumptioTaxSetting?.TaxValue;
  };

  const nominationFeeAmount = selectedStaffInfo?.IsNominationFee 
  ? selectedStaffInfo.NominationFee 
  : 0;
  const consumptionTaxAmount = (selectedStaffInfo?.NominationFee ?? 0) * getTaxRate() / 100;
  
  return (
    <div className="confirmation-section">
      <div className="alert alert-warning mb-4">
        <FormattedMessage id="please_check_reservation_details" />
      </div>

      <div className="card-body p-0 border mb-3">
        <div className="row m-0">
          <div className="col-4 bg-light p-3 border-bottom border-end">
            <FormattedMessage id="date_time" />
          </div>
          <div className="col-8 p-3 border-bottom">
            {
              values.selectedDate && 
              <>
                {parseDateTime(values.selectedDate).date} (
                  {formatMessage(
                    moment(parseDateTime(values.selectedDate).date).format("ddd")
                  )}
                )
                {" "}
                {moment(parseDateTime(values.selectedDate).time, "HH:mm:ss").format(
                  "HH:mm"
                )}
              </>
            }
          </div>
        </div>

        <div className="row m-0">
          <div className="col-4 bg-light p-3 border-bottom border-end">
            <FormattedMessage id="store_details" />
          </div>
          <div className="col-8 p-3 border-bottom text-wrap">
            <div className=" mb-2">{storeDetails.StoreName}</div>
            {/* <div className="mb-2">
              Phone Number: {storeDetails.MobileNumber}
            </div> */}
            <div className="mb-3 text-secondary small text-wrap">
              {storeDetails.Address}
            </div>
            <div className="text-wrap">{storeDetails.location}</div>
            {storeDetails.Url ? (
              <a
                href={storeDetails.Url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary text-decoration-none"
              >
                📍 <FormattedMessage id="map" />
              </a>
            ) : (
              <div
                rel="noopener noreferrer"
                className="text-primary text-decoration-none"
              >
                📍 <FormattedMessage id="no_location_available" />
              </div>
            )}
          </div>
        </div>

        <div className="row m-0">
          <div className="col-4 bg-light p-3 border-bottom border-end">
            <FormattedMessage id="total_estimated_time" />
          </div>
          <div className="col-8 p-3 border-bottom">
            {formatTimeDisplay(Number(totalDuration() ?? 0))}
          </div>
        </div>

        <div className="row m-0">
          <div className="col-4 bg-light p-3 border-bottom border-end">
            <FormattedMessage id="menu" />
          </div>
          <div className="col-8 p-3 border-bottom">
            {selectedServicesInfo.map((service, index) => {
              return (
                service && (
                  <div key={index} className="">
                    <div className="row g-0 mb-2">
                      <div className="col-lg-8 col-12 text-wrap">{service.Name}</div>
                      <div className="col-lg-4 col-12">
                        <div className="row g-1">
                          <span className="col-6 text-lg-end text-secondary"> 
                            <i className="bi bi-currency-yen"></i>
                            {formatNumberWithCommas(service.FeeIncludingTax)}
                          </span>
                          <span className="col-6 text-end text-secondary">
                            {formatTimeDisplay(Number(service.Time ?? 0))}
                          </span>
                        </div>
                      </div>
                    </div>
                    {service?.OptionIds?.map((optionId: number) => {
                      const option =
                        service?.TreatmentData?.optionVm?.length > 0
                          ? service.TreatmentData?.optionVm?.find(
                              (op: any) => op.OptionId == optionId
                            )
                          : null;
                      return (
                        option && (
                          <>
                            <div className="row g-0 mb-2">
                              <div className="col-lg-8 col-12 text-wrap">{option.OptionName}
                                <span className="badge bg-primary rounded ms-2">
                                  <FormattedMessage id="option" />
                                </span>
                              </div>
                              <div className="col-lg-4 col-12">
                                <div className="row g-1">
                                  <span className="col-6 text-lg-end text-secondary"> 
                                  {/* <i className="bi bi-currency-yen"></i>{option.FeeExcludingTax} + <i className="bi bi-currency-yen"></i>
                                    {option.TaxAmount} (
                                    {getAllTaxOptions.length > 0
                                      ? getAllTaxOptions?.find(
                                          (tax) => tax.id === option.TaxId
                                        )?.value
                                      : "0 %"}
                                    ) =  */}
                                    <i className="bi bi-currency-yen"></i>
                                    {formatNumberWithCommas(
                                      option.FeeIncludingTax
                                    )}
                                  </span>
                                  <span className="col-6 text-end text-secondary">
                                    {formatTimeDisplay(
                                      Number(option.TimeValue ?? 0)
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </>
                        )
                      );
                    })}
                  </div>
                )
              );
            })}
          </div>
        </div>

        <div className="row m-0">
          <div className="col-4 bg-light p-3 border-bottom border-end">
            <FormattedMessage id="staff_nomination_fee" />
          </div>
          <div className="col-8 p-3 border-bottom">
            {selectedStaffInfo?.Name}
            <span className="text-secondary ms-2">
              - <i className="bi bi-currency-yen me-1"></i>
              {selectedStaffInfo?.IsNominationFee
                ? formatNumberWithCommas(selectedStaffInfo?.NominationFee)
                : "0"}
            </span>
          </div>
        </div>

        <div className="row m-0">
          <div className="col-4 bg-light p-3 border-bottom border-end">
            <FormattedMessage id="amount_to_pay" />
          </div>
          <div className="col-8 p-3 border-bottom">
            <div className="">
              <i className="bi bi-currency-yen"></i>
              {formatNumberWithCommas(
                totalAmount() + nominationFeeAmount + consumptionTaxAmount
              ) + " "}{" "}
            </div>
            <div className="text-secondary small">
              (<FormattedMessage id="tax_label" />:{" "}
              <i className="bi bi-currency-yen"></i>{" "}
              {formatNumberWithCommas(totalTaxAmount() + consumptionTaxAmount)} )
            </div>
          </div>
        </div>

        <div className="row m-0">
          <div className="col-4 bg-light p-3 border-bottom border-end">
            <FormattedMessage id="payment_methods" />
          </div>
          <div className="col-8 p-3 border-bottom">
            {formatMessage(paymentType[0])}
          </div>
        </div>

        <div className="row m-0">
          <div className="col-4 bg-light p-3 border-bottom border-end">
            <FormattedMessage id="cancellation_date_time" />
          </div>
          <div className="col-8 p-3 border-bottom text-wrap">
            {/* <FormattedMessage id="cancellation_24_hours" /> */}
            {headquarterCancelationPolicyDetails.HeadquarterCancelationText &&
              headquarterCancelationPolicyDetails.HeadquarterCancelationText?.replace(
                "{time}",
                String(getReservationSettingDetail?.CancelationTime)
              )}
          </div>
        </div>

        <div className="row m-0">
          <div className="col-4 bg-light p-3 border-bottom border-end">
            <FormattedMessage id="cancellation_policy" />
            <span className="text-danger">*</span>
          </div>
          <div className="col-8 p-3 px-5 border-bottom text-wrap">
            <div
              dangerouslySetInnerHTML={{
                __html:
                  headquarterCancelationPolicyDetails.HeadquarterCancelationPolicy,
              }}
            ></div>
            <div className="form-check mt-3">
              <Field
                type="checkbox"
                id="agreedToTerms"
                name="agreedToTerms"
                className="form-check-input"
              />
              <label
                htmlFor="agreedToTerms"
                className="form-check-label text-wrap"
              >
                <FormattedMessage id="precaution_policy_details" />
              </label>
              <ErrorMessage
                name="agreedToTerms"
                component="div"
                className="text-danger small mt-1"
              />
            </div>
          </div>
        </div>

        <div className="row m-0">
          <div className="col-4 bg-light p-3 border-bottom border-end">DM</div>
          <div className="col-8 p-3 px-5 border-bottom">
            <div className="form-check">
              <Field
                type="checkbox"
                id="dmAgreeToTerms"
                name="dmAgreeToTerms"
                className="form-check-input"
              />
              <label
                htmlFor="dmAgreeToTerms"
                className="form-check-label text-wrap"
              >
                <FormattedMessage id="promotional_message" />
              </label>
            </div>
            {/* {JSON.stringify(accordionData)} */}
          </div>
        </div>

        <div className="row m-0">
          <div className="col-4 bg-light p-3 border-bottom border-end">
            <FormattedMessage id="precaution" />
            <span className="text-danger">*</span>
          </div>
          <div className="col-8 p-3 px-5 border-bottom text-wrap">
            {getReservationSettingDetail?.Precaution}
            <div className="form-check">
              <Field
                type="checkbox"
                id="agreeToPrecaution"
                name="agreeToPrecaution"
                className="form-check-input"
              />
              <label
                htmlFor="agreeToPrecaution"
                className="form-check-label text-wrap"
              >
                <FormattedMessage id="precaution_policy_details" />
              </label>
              <ErrorMessage
                name="agreeToPrecaution"
                component="div"
                className="text-danger small mt-1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

const BookingComplete: React.FC<{ StoreCode: string }> = observer(
  ({ StoreCode }) => {
    const history = useHistory();
    const { bookingManagementStore } = useStore();
    const {
      addUpdateCustomerState,
      addUpdateAppointmentState,
      appointmentType,
    } = bookingManagementStore;
    return (
      <div className="complete-section text-center py-5">
        <h4 className="thank_you_title">
          <FormattedMessage id="thank_you_reservation" />
        </h4>
        <div className="success-check mb-4">
          <svg
            fill="none"
            height="90"
            viewBox="0 0 24 24"
            width="90"
            xmlns="http://www.w3.org/2000/svg"
            id="fi_10995387"
          >
            <g clipRule="evenodd" fillRule="evenodd">
              <path
                d="m12 2.75c-5.10863 0-9.25 4.14137-9.25 9.25 0 5.1086 4.14137 9.25 9.25 9.25 5.1086 0 9.25-4.1414 9.25-9.25 0-5.10863-4.1414-9.25-9.25-9.25zm-10.75 9.25c0-5.93706 4.81294-10.75 10.75-10.75 5.9371 0 10.75 4.81294 10.75 10.75 0 5.9371-4.8129 10.75-10.75 10.75-5.93706 0-10.75-4.8129-10.75-10.75z"
                fill="#26d701"
              ></path>
              <path
                d="m16.0303 8.96967c.2929.29289.2929.76777 0 1.06063l-5 5c-.2929.2929-.7677.2929-1.06063 0l-2-2c-.29289-.2929-.29289-.7677 0-1.0606s.76777-.2929 1.06066 0l1.46967 1.4696 4.4697-4.46963c.2929-.29289.7677-.29289 1.0606 0z"
                fill="#00ab08"
              ></path>
            </g>
          </svg>
        </div>

        <p className="mb-4">
          {(addUpdateCustomerState.success &&
            addUpdateAppointmentState.success) == true && (
            <FormattedMessage id="registered_customer_booking_message" />
          )}
          <br></br>
          <FormattedMessage id="confirmation_email" />
        </p>
        {(addUpdateAppointmentState.success &&
          addUpdateCustomerState.success) == true ? (
          <React.Fragment>
            <button
              type="button"
              onClick={() => {
                history.push(RoutesConstants.CustomerRegistration);
              }}
              className="btn btn-primary px-2 px-md-4"
            >
              <FormattedMessage id="go_lizera_customer_login" />
            </button>
          </React.Fragment>
        ) : getTokenFromLocalStorage() == "" ? (
          <React.Fragment>
            {appointmentType == 2 ? (
              <button
                type="button"
                onClick={() => {
                  // history.push(RoutesConstants.NavigationPage);
                  history.push(`/Store/${StoreCode}`);
                }}
                className="btn btn-primary px-2 px-md-4"
              >
                <FormattedMessage id="go_to_store_details" />
              </button>
            ) : appointmentType == 3 ? (
              <button
                type="button"
                onClick={() => {
                  history.push(RoutesConstants.CustomerLogin);
                }}
                className="btn btn-primary px-2 px-md-4"
              >
                <FormattedMessage id="go_to_customer_login" />
              </button>
            ) : (
              <button
                type="button"
                onClick={() => {
                  history.push(RoutesConstants.StoreListPage);
                }}
                className="btn btn-primary px-2 px-md-4"
              >
                <FormattedMessage id="go_lizera_homepage" />
              </button>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <button
              type="button"
              onClick={() => {
                history.push(RoutesConstants.ReservationList);
              }}
              className="btn btn-primary px-2 px-md-4"
            >
              <FormattedMessage id="go_lizera_reservations" />
            </button>
          </React.Fragment>
        )}
      </div>
    );
  }
);

const BookingFailed: React.FC<{
  formikProps: FormikProps<BookingFormValues>;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
}> = observer(({ formikProps, setCurrentStep }) => {
  const { setFieldValue, setFieldTouched } = formikProps;
  const { bookingManagementStore } = useStore();
  const { appointmentType, addUpdateAppointmentState } = bookingManagementStore;
  const history = useHistory();
  return (
    <div className="complete-section text-center py-5">
      <h4 className="thank_you_title">
        {formatMessage("incomplete_reservation")}
      </h4>
      <div className="success-check mb-4">
        <svg
          id="fi_11650356"
          height="90"
          width="90"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
          data-name="Layer 1"
        >
          <path
            d="m183.653 359.606 65.681-65.681a9.427 9.427 0 0 1 13.331 0l65.682 65.682 31.26-31.26-65.682-65.682a9.427 9.427 0 0 1 0-13.331l65.682-65.681-31.26-31.26-65.682 65.681a9.425 9.425 0 0 1 -13.331 0l-65.681-65.681-31.26 31.26 65.681 65.681a9.425 9.425 0 0 1 0 13.331l-65.681 65.682zm72.347-45.684-65.681 65.678a9.428 9.428 0 0 1 -13.332 0l-44.587-44.588a9.427 9.427 0 0 1 0-13.331l65.677-65.681-65.677-65.681a9.428 9.428 0 0 1 0-13.332l44.587-44.587a9.428 9.428 0 0 1 13.332 0l65.681 65.677 65.681-65.677a9.426 9.426 0 0 1 13.332 0l44.587 44.587a9.427 9.427 0 0 1 0 13.331l-65.678 65.682 65.678 65.681a9.428 9.428 0 0 1 0 13.332l-44.587 44.587a9.428 9.428 0 0 1 -13.332 0zm209.98-57.922c0 115.969-94.011 209.98-209.98 209.98s-209.98-94.011-209.98-209.98 94.011-209.98 209.98-209.98 209.98 94.011 209.98 209.98zm-209.98-228.836c126.382 0 228.836 102.454 228.836 228.836s-102.454 228.836-228.836 228.836-228.836-102.454-228.836-228.836 102.454-228.836 228.836-228.836z"
            fill="#f24646"
            fillRule="evenodd"
          ></path>
        </svg>
      </div>

      <p className="mb-4">
        {formatMessage("cannot_complete_booking")}
        <br />
        {formatMessage("try_again_later")}
        <br />
        Error :{" "}
        {addUpdateAppointmentState.error != "" &&
          addUpdateAppointmentState.error}
      </p>

      {/* check if the customer is logged in or not */}
      {getTokenFromLocalStorage() == "" ? (
        <React.Fragment>
          {/* If the customer is not logged in and booking failed for walkin user*/}
          {appointmentType == 2 ? (
            <button
              type="button"
              onClick={() => {
                setFieldValue("selectedDate", null);
               setFieldValue("agreedToTerms", false);
                setFieldTouched(
                  "agreedToTerms",
                  false,
                  false
                );
                setFieldValue("agreeToPrecaution", false);
                setFieldTouched(
                  "agreeToPrecaution",
                  false,
                  false
                );
                setFieldValue("dmAgreeToTerms", false);
                setFieldTouched(
                  "dmAgreeToTerms",
                  false,
                  false
                );
                setCurrentStep(2);
                // history.push(RoutesConstants.BookingManagement);
              }}
              className="btn btn-primary px-2 px-md-4"
            >
              <FormattedMessage id="go_back_to_step_2" />
            </button>
          ) : //  If the customer is not logged in and booking failed for new register user
          appointmentType == 3 ? (
            <button
              type="button"
              onClick={() => {
                setFieldValue("agreedToTerms", false);
                setFieldTouched(
                  "agreedToTerms",
                  false,
                  false
                );
                setFieldValue("agreeToPrecaution", false);
                setFieldTouched(
                  "agreeToPrecaution",
                  false,
                  false
                );
                setFieldValue("dmAgreeToTerms", false);
                setFieldTouched(
                  "dmAgreeToTerms",
                  false,
                  false
                );
                setCurrentStep(3);
                // history.push(RoutesConstants.BookingManagement);
              }}
              className="btn btn-primary px-2 px-md-4"
            >
              <FormattedMessage id="go_back_to_step_3" />
            </button>
          ) : (
            //  If the customer is not logged in and booking failed for verify login user
            <button
              type="button"
              onClick={() => {
                setFieldValue("selectedDate", null);
                setFieldValue("agreedToTerms", false);
                setFieldTouched(
                  "agreedToTerms",
                  false,
                  false
                );
                setFieldValue("agreeToPrecaution", false);
                setFieldTouched(
                  "agreeToPrecaution",
                  false,
                  false
                );
                setFieldValue("dmAgreeToTerms", false);
                setFieldTouched(
                  "dmAgreeToTerms",
                  false,
                  false
                );
                setCurrentStep(2);
                // history.push(RoutesConstants.BookingManagement);
              }}
              className="btn btn-primary px-2 px-md-4"
            >
              <FormattedMessage id="go_back_to_step_2" />
            </button>
          )}
        </React.Fragment>
      ) : (
        // If the customer is logged in and booking failed
        <React.Fragment>
          <button
            type="button"
            onClick={() => {
              setFieldValue("selectedDate", null);
              setFieldValue("agreedToTerms", false);
                setFieldTouched(
                  "agreedToTerms",
                  false,
                  false
                );
                setFieldValue("agreeToPrecaution", false);
                setFieldTouched(
                  "agreeToPrecaution",
                  false,
                  false
                );
                setFieldValue("dmAgreeToTerms", false);
                setFieldTouched(
                  "dmAgreeToTerms",
                  false,
                  false
                );
              setCurrentStep(2);
              // history.push(RoutesConstants.ReservationList);
            }}
            className="btn btn-primary px-2 px-md-4"
          >
            <FormattedMessage id="go_back_to_step_2" />
          </button>
        </React.Fragment>
      )}
    </div>
  );
});

const BookingManagement: React.FC = (props: any) => {
  // Get the current location from react-router
  const location = useLocation();
  // State for the selected store ID
  const [storeId, setStoreId] = useState<number>(-1);
  // Get the store code from the URL params
  const { storeCode } = useParams<{ storeCode: string }>();
  // State for the current step in the booking process
  const [currentStep, setCurrentStep] = useState<number>(1);
  // Get booking details from navigation state if available
  const bookingDetailFromReservationList = location.state
    ? (location.state as any)
    : null;
  // State for booking details object
  const [bookingDetails, setBookingDetails] = useState<any>();
  // State to track open/closed status for any node by its id.
  const [openNodes, setOpenNodes] = useState<{ [key: string]: boolean }>({});
  // Ref to access Formik methods and values
  const formikRef = useRef<FormikProps<BookingFormValues> | null>(null);
  const { values } = formikRef.current || {};
  // State for initial form data
  const [initialData, setInitialData] =
    useState<BookingFormValues>(initialValues);
  // State for selected category IDs
  const [categoryIds, setCategoryIds] = useState<any>([]);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  // Get stores and booking-related stores from context
  const {
    masterManagementStore,
    categoryManagementStore,
    bookingManagementStore,
    storeManagementStore,
    reservationSchedulerStore,
    headquarterStore,
    storeCmsStore,
    authStore,
    preferencesStore,
  } = useStore();

  // Destructure headquarterStore methods and state
  const { GetHeadquarterCancelationBookingStoreDetail } = headquarterStore;

  // Destructure storeCmsStore methods and state
  const {
    GetStoreDetailsByStoreCodeAnonymousService,
    storeCodeDetails,
    resetStoreCodeDetails,
    cmsStoreAnonymousState,
    resetCMSStoreAnonymousState
  } = storeCmsStore;

  // Destructure categoryManagementStore methods and state
  const { allCategoryState, GetAllCategoriesServiceReservation } =
    categoryManagementStore;
  // Destructure bookingManagementStore methods and state
  const {
    addUpdateAppointmentState,
    AddAppointmentService,
    updateBookingData,
    getAccordionDataById,
    resetBookingStore,
    resetAppointmentState,
    resetAppointmentStateError,
    authenticateCustomerState,
    resetAddUpdateCustomer,
    GetTreatmentOptionMenuListByCatIdCustomerService
  } = bookingManagementStore;
  // Destructure storeManagementStore methods and state
  const {
    GetStoreManagementByIdService,
    resetStoreManagementDetail,
    storeDetail,
    storeState,
    store,
  } = storeManagementStore;
  // Destructure masterManagementStore methods and state
  const {
    getAllStaffOptionsForBooking,
    staffOptionsState,
    storeOptionsState,
    taxSettingState,
    timeSettingState,
    GetReservationSettingByIdService,
    getReservationSettingDetail,
    getByIdReservationSettingState,
    getAllTimeOptions,
    GetAllStoreOptionService,
    getAllStoreOptions,
    GetAllTimeService,
    getAllTaxOptions,
    GetAllTaxOptionService,
    GetReservationSettingMinMaxTime,
    GetConsumptionTaxByHeadquarterIdService,
    getAllStaffOptions,
    consumptioTaxSetting,
    getByIdConsumptionTaxState,
  } = masterManagementStore;
  // Destructure reservationSchedulerStore methods
  const { GetStaffAppointmentsListService } = reservationSchedulerStore;
  // Get selected staff info from staff options
  const selectedStaffInfo = getAllStaffOptionsForBooking.find(
    (s) => s.Id === formikRef.current?.values?.selectedStaff
  );
  const history = useHistory();

  // Function to get initial storeId
  const getInitialStoreId = () => {
    if (bookingDetailFromReservationList?.StoreId)
      return Number(bookingDetailFromReservationList.StoreId);
    if (storeId) return Number(storeId);
    return 0;
  };

  // If logged in but not as Customer, force logout
  if (
    getTokenFromLocalStorage() !== "" &&
    getUserTypeFromLocalStorage() !== "Customer" &&
    !authStore.logoutInprogress
  ) {
    authStore.logout();
  }

  // Show error toast if logout fails
  useEffect(() => {
    if (authStore.logoutError) {
      toast.error(formatMessage(authStore.logoutError));
      authStore.resetLogout();
    }
  }, [authStore.logoutError]);

  // On successful logout, show success toast, reset stores, and redirect
  useEffect(() => {
    if (authStore.logoutSuccess) {
      authStore.resetLogout();
      history.push(RoutesConstants.CustomerLogin);
    }
  }, [authStore.logoutSuccess]);

  // Map selected services to detailed info for calculations
  const selectedServicesInfo =
    formikRef?.current?.values?.selectedServices?.map((service: any) => {
      const TreatmentData = getAccordionDataById(Number(service.TreatmentId));

      // Return null if TreatmentData is not available
      if (!TreatmentData) {
        return null;
      }

      // Now it's safe to use TreatmentData.Time
      const timeOption = getAllTimeOptions?.find(
        (time) => time.id === TreatmentData.Time
      );
      const getTime = timeOption?.value ? Number(timeOption.value) : 0;

      return {
        Name: TreatmentData.TreatmentName,
        FeeExcludingTax: TreatmentData.FeeExcludingTax,
        FeeIncludingTax: TreatmentData.FeeIncludingTax,
        Tax: TreatmentData.TaxId,
        TaxAmount: TreatmentData.TaxAmount,
        Time: getTime,
        TreatmentData: TreatmentData,
        OptionIds: service.OptionIds,
      };
    });

  // Calculate total duration of selected services and options
  const totalDuration = () => {
    let totalTime = 0;
    selectedServicesInfo?.map((service) => {
      totalTime += service?.Time ? service.Time : 0;
      service?.OptionIds?.map((optionId: any) => {
        const option =
          service?.TreatmentData?.optionVm?.length > 0
            ? service.TreatmentData?.optionVm?.find(
                (op: any) => op.OptionId == optionId
              )
            : null;
        totalTime += option.TimeValue;
      });
    });
    return totalTime;
  };

  const totalDurationWithZeroTimeTreatmentCheck = () => {
    let totalTime = 0;
    const selectedServicesInfo =
      formikRef?.current?.values?.selectedServices?.map((service: any) => {
        const TreatmentData = getAccordionDataById(Number(service.TreatmentId));

        // Return null if TreatmentData is not available
        if (!TreatmentData) {
          return null;
        }

        // Now it's safe to use TreatmentData.Time
        const timeOption = getAllTimeOptions?.find(
          (time) => time.id === TreatmentData.Time
        );
        const getTime = timeOption?.value ? Number(timeOption.value) : 0;

        return {
          Name: TreatmentData.TreatmentName,
          FeeExcludingTax: TreatmentData.FeeExcludingTax,
          FeeIncludingTax: TreatmentData.FeeIncludingTax,
          Tax: TreatmentData.TaxId,
          TaxAmount: TreatmentData.TaxAmount,
          Time: getTime,
          TreatmentData: TreatmentData,
          OptionIds: service.OptionIds,
        };
      });
    selectedServicesInfo?.map((service) => {
      totalTime += service?.Time ? service.Time : 0;
      service?.OptionIds?.map((optionId: any) => {
        const option =
          service?.TreatmentData?.optionVm?.length > 0
            ? service.TreatmentData?.optionVm?.find(
                (op: any) => op.OptionId == optionId
              )
            : null;
        totalTime += option.TimeValue;
      });
    });
    return totalTime;
  };

  // Calculate nomination fee for selected staff
  const totalNominationFee = (staffId: number) => {
    let nominationFee = 0;
    const staff = getAllStaffOptions.find((s) => s.id === staffId);
    if (staff && staff.data?.NominationFee) {
      nominationFee += staff.data.NominationFee || 0; // Add nomination fee if applicable
    }
    return nominationFee;
  };

  // Calculate total amount (including options)
  const totalAmount = () => {
    let totalFee = 0;
    selectedServicesInfo?.map((service) => {
      totalFee += service?.FeeIncludingTax;
      service?.OptionIds?.map((optionId: any) => {
        const option =
          service?.TreatmentData?.optionVm?.length > 0
            ? service.TreatmentData?.optionVm?.find(
                (op: any) => op.OptionId == optionId
              )
            : null;
        totalFee += option.FeeIncludingTax;
      });
    });
    return totalFee;
  };

  // Calculate total tax amount (including options)
  const totalTaxAmount = () => {
    let totalTax = 0;
    selectedServicesInfo?.map((service) => {
      totalTax += service?.TaxAmount;
      service?.OptionIds?.map((optionId: any) => {
        const option =
          service?.TreatmentData?.optionVm?.length > 0
            ? service.TreatmentData?.optionVm?.find(
                (op: any) => op.OptionId == optionId
              )
            : null;
        totalTax += option.TaxAmount;
      });
    });
    return totalTax;
  };

  // Get tax value by taxId
  const getTaxValue = (taxId: number) => {
    const taxOption = getAllTaxOptions?.find((taxes) => taxes?.id == taxId);
    if (taxOption) {
      return taxOption.value;
    } else {
      return null;
    }
  };

  // Get time value by timeId
  const getTimeValue = (timeId: number) => {
    const timeOption = getAllTimeOptions?.find((time) => time?.id == timeId);
    if (timeOption) {
      return timeOption.value;
    } else {
      return null;
    }
  };

  useEffect(() => {
    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);

      // Start 30 min timer
      timerRef.current = setTimeout(() => {
        window.location.reload(); // refresh page
      }, 60 * 60 * 1000); // 60 minutes
    };

    // Keyboard + Mouse events only
    const events = ["mousemove", "mousedown", "keydown"];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // initialize on mount

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  // Set storeId on mount or when dependencies change
  useEffect(() => {
    setStoreId(getInitialStoreId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeId, bookingDetailFromReservationList]);

  // Fetch store details by store code
  useEffect(() => {
    if (storeCode !== "") {
      GetStoreDetailsByStoreCodeAnonymousService(storeCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeCode]);

  // Update storeId when storeCodeDetails changes
  useEffect(() => {
    if (storeCode !== "" && storeCodeDetails && storeCodeDetails?.Id > 0) {
      setStoreId(storeCodeDetails?.Id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeCode, storeCodeDetails]);

   useEffect(() => {
    if (storeCodeDetails && storeCodeDetails.Id === 0 && storeCode !== "" && cmsStoreAnonymousState.error) {
      // setUrlStoreId(storeCodeDetails.Id);
      history.push(RoutesConstants.InvalidStore)
    }
  }, [storeCodeDetails, cmsStoreAnonymousState.error]);

  // If booking details are present from reservation list, set initial data
  useEffect(() => {
    if (bookingDetailFromReservationList) {
      setStoreId(bookingDetailFromReservationList?.StoreId ?? -1);
      if (
        bookingDetailFromReservationList.AppointmentStatus ===
        bookingStatusEnum.Complete
      ) {
        let serviceDataId: any = [];
        let serviceData: any = [];
        let categoryId: any = [];

        bookingDetailFromReservationList.ServiceRequestedVMss.forEach(
          (service: any) => {
            if (service.ServiceType === serviceTypeEnum.Treatment) {
                  GetTreatmentOptionMenuListByCatIdCustomerService(
              service.ParentId,
              null,
              bookingDetailFromReservationList.StoreId,
              storeCodeDetails.BusinessTypeId
            );        
              
              serviceDataId.push({
                TreatmentId: service.ServiceId,
                OptionIds: [],
              });
              serviceData.push({
                TreatmentId: service,
                OptionIds: [],
              });
              categoryId.push(service.ParentId);
            } else if (service.ServiceType === serviceTypeEnum.Option) {
              let treatmentIndex = serviceDataId.findIndex(
                (t: any) => Number(t.TreatmentId) === Number(service.ParentId)
              );
              if (treatmentIndex > -1) {
                serviceDataId[treatmentIndex].OptionIds.push(service.ServiceId);
                serviceData[treatmentIndex].OptionIds.push(service);
              }
            }
          }
        );

        setCategoryIds(categoryId);
        setInitialData({
          ...initialValues,
          selectedServices: serviceDataId,
        });
      }
    }
  }, [bookingDetailFromReservationList]);

  // Fetch store and reservation settings when storeId and storeCode are set
  useEffect(() => {
    if (storeId > 0) {
      resetAppointmentState();
      formikRef.current?.resetForm();
      localStorage.setItem("lizera_store_id", storeId?.toString());
      // GetStoreManagementByIdService(storeId);
      GetReservationSettingMinMaxTime(storeId);
      GetReservationSettingByIdService(storeId);
      // GetStoreCmsByIdAnonymousService(storeId);
      let currentDate = new Date();
      GetStaffAppointmentsListService(
        -1,
        storeId,
        moment(
          `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}`,
          "YYYY-M"
        )
          .startOf("month")
          .format("YYYY-MM-DD"),
        moment(
          `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}`,
          "YYYY-M"
        )
          .endOf("month")
          .format("YYYY-MM-DD")
      );
      setCurrentStep(1);
    }
  }, [storeId]);

  // Reset customer and appointment state on mount
  useEffect(() => {
    resetBookingStore();
    resetAddUpdateCustomer();
    resetAppointmentState();
    setCurrentStep(1);
    formikRef.current?.resetForm();
    // resetStoreCodeDetails();
    initialValues.selectedServices = [];
    GetAllStoreOptionService();
    return(()=>{
      resetCMSStoreAnonymousState();
    })
  }, []);

  // Fetch CMS, categories, time, tax, and headquarter cancellation policy when store details change
  useEffect(() => {
    if (storeCodeDetails.Id > 0 && storeId > 0) {
      setCurrentStep(1);
      GetAllCategoriesServiceReservation(storeCodeDetails?.BusinessTypeId);
      GetAllTimeService(storeCodeDetails?.BusinessTypeId);
      GetAllTaxOptionService(storeCodeDetails?.BusinessTypeId);
      if (storeCodeDetails?.HeadquarterId) {
        GetConsumptionTaxByHeadquarterIdService(
          storeCodeDetails?.HeadquarterId
        );
        GetHeadquarterCancelationBookingStoreDetail(
          storeId,
          storeCodeDetails?.HeadquarterId
        );
      }
    }
  }, [storeId, storeCodeDetails]);

  // Move to booking complete step if appointment is successful
  useEffect(() => {
    if (addUpdateAppointmentState.success) {
      setCurrentStep(4);
      resetBookingStore();
    }
  }, [addUpdateAppointmentState.success]);

  // Move to booking failed step if appointment has error
  useEffect(() => {
    if (addUpdateAppointmentState.error) {
      setCurrentStep(4);
    }
  }, [addUpdateAppointmentState.error]);

  // Scroll to top when current step changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // console.log("currentStep", currentStep);
  }, [currentStep]);

  // Check if a step is accessible based on form values
  const isStepAccessible = (
    values: BookingFormValues,
    step: number
  ): boolean => {
    // Step 1 is always accessible
    if (step === 1) return true;
    // Step 2 is accessible if services are selected
    if (step === 2) return values.selectedServices.length > 0;
    // Step 3 is accessible if staff and date are selected
    if (step === 3)
      return Boolean(values.selectedStaff) && Boolean(values.selectedDate);
    // Step 4 is only accessible after confirmation
    if (step === 4) return values.agreedToTerms;
    return false;
  };

  // Handle form submission
  const handleSubmit = (values: BookingFormValues) => {
    resetAppointmentStateError();
    // Process the final submission
    let servicesArray: any[] = [];
    let nominationFee = values?.selectedStaff > 0 ? totalNominationFee(values.selectedStaff) : 0; // Calculate nomination fee
    let consumtionTaxPercent =
      typeof consumptioTaxSetting.TaxValue === "string"
        ? parseInt(consumptioTaxSetting.TaxValue)
        : consumptioTaxSetting.TaxValue;
    let consumptionTax = (nominationFee * consumtionTaxPercent) / 100;
    // Prepare the booking object with all necessary details
    let addObj = {
      CustomerId: 0, // Default customer ID
      StoreId: Number(storeId), // Store ID from the selected store
      // Staff preference based on selected staff
      StaffPreference:
        values.selectedStaff == -3
          ? 0
          : values.selectedStaff == -2
          ? 2
          : values.selectedStaff == -1
          ? 1
          : 3,
      RequestedStaffId: values.selectedStaff > 0 ? values.selectedStaff : null, // Requested staff ID if applicable
      AssignedStaffId: values.selectedStaff > 0 ? values.selectedStaff : null, // Assigned staff ID if applicable
      Date: values.selectedDate
        ? `${parseDateTime(values.selectedDate).date}T00:00:00.000Z`
        : "", // Appointment date
      Time: values.selectedDate
        ? parseDateTime(values.selectedDate).time + ":00"
        : "", // Appointment time
      AppointmentStatus: bookingStatusEnum.Reserved, // Default booking status
      PaymentType: paymentType.OnSitePayment, // Payment type
      NominationFee:
        values.selectedStaff > 0
          ? selectedStaffInfo?.IsNominationFee
            ? nominationFee
            : 0
          : 0, // Nomination fee if applicable
      TotalTime: totalDuration(), // Total duration of the appointment
      TotalAmount: totalAmount() + nominationFee + Math.round(consumptionTax), // Total amount for the appointment
      ConsumptionTax: Math.round(consumptionTax), // Set consumption tax
      TotalTaxes: totalTaxAmount(), // Total taxes for the appointment
      CustomerType: CustomerTypeEnum.Registered, // Customer type (Registered)
      RegisteredBy: RegisteredByEnum.Self, // Registered by self
      Service: servicesArray, // List of selected services
      CancelationType: CancellationTypeEnum.None, // Default cancellation type
      BookingType: BookingTypeEnum.NewWeb, // Booking type (web)
      PrecautionType: values?.agreeToPrecaution == false ? 0 : 1,
      ReservationMemo: "", // Reservation memo (optional)
      PostBreakTime: getTimeValue(getReservationSettingDetail?.IntervalTime), // Post-break time interval
      HeadquarterId: storeCodeDetails?.HeadquarterId,
      DmStore: values?.dmAgreeToTerms
    };

    // Check if there are selected services
    if (values.selectedServices?.length > 0) {
      values.selectedServices?.map((service) => {
        const treatmentData = getAccordionDataById(service.TreatmentId);
        if (treatmentData) {
          // Add treatment details to the services array
          servicesArray.push({
            CustomerId: 0,
            ServiceId: service.TreatmentId,
            ParentId: treatmentData.CategoryId,
            ServiceType: serviceTypeEnum.Treatment,
            ServiceName: treatmentData.TreatmentName,
            Charges: treatmentData.FeeIncludingTax.toString(),
            Tax: getTaxValue(treatmentData.TaxId),
            TaxAmount: treatmentData.TaxAmount,
            TimeValue: getTimeValue(treatmentData.Time),
          });
          if (service.OptionIds?.length > 0) {
            service?.OptionIds?.map((id: number) => {
              const option =
                treatmentData?.optionVm?.length > 0
                  ? treatmentData?.optionVm?.find(
                      (op: any) => op.OptionId == id
                    )
                  : null;
              if (option) {
                // Add option details to the services array
                servicesArray.push({
                  CustomerId: 0,
                  ServiceId: option.OptionId,
                  ServiceType: serviceTypeEnum.Option,
                  ParentId: treatmentData.Id,
                  ServiceName: `${treatmentData.Id}_${option.OptionName}`,
                  Charges: option.FeeIncludingTax.toString(),
                  TaxAmount: option.TaxAmount,
                  Tax: getTaxValue(option.TaxId),
                  TimeValue: option?.TimeValue,
                });
              }
            });
          }
        }
      });
    }

    setBookingDetails(addObj); // Set the booking details object
    if (
      isCurrentDateTimeGreater(
        moment(addObj.Date).format("YYYY-MM-DD"),
        addObj.Time
      )
    )
      toast.error(formatMessage("Cannot Update Past Events"));
    else {
      if (getTokenFromLocalStorage() == "") {
        props.authorizeCustomerToggleHandler(); // Trigger customer authorization if no token is found
      } else {
        let customerId = getcustIdFromToken(); // Retrieve customer ID from token
        if (customerId > 0) {
          if (
            getHoursDifferenceFromNow(
              moment(addObj?.Date).format("YYYY-MM-DD"),
              addObj.Time
            ) < getReservationSettingDetail?.NewReservationTime
          ) {
              let errorMsg = formatMessage("you_can_add_reservation_prior_to_hour");
              toast.error(errorMsg.replace("{date}", getReservationSettingDetail?.NewReservationTime));
              // Show error if time difference is less than allowed
          } else {
            AddAppointmentService(
              updateBookingData(
                {
                  ...addObj,
                  BusinessTypeId: storeCodeDetails?.BusinessTypeId,
                  HeadquarterId: storeCodeDetails?.HeadquarterId,
                },
                customerId
              )
            ); // Add appointment service with updated booking data
          }
        }
      }
    }
  };

  // Validate if option is mandatory for selected treatments
  const validateOptionMandatoryForTreatment = (selectedServices: any[]) => {
    const treatmentsMissingOptions: string[] = [];
    const allSelectedOptionIds = selectedServices.flatMap(
      (service: any) => service.OptionIds || []
    );

    for (const service of selectedServices) {
      const treatmentData = getAccordionDataById(service.TreatmentId);
      if (!treatmentData) continue;

      if (
        treatmentData.OptionMenu === 0 &&
        Array.isArray(treatmentData.optionVm) &&
        treatmentData.optionVm.length > 0
      ) {
        const treatmentOptionIds = treatmentData?.optionVm.map(
          (opt: any) => opt.OptionId
        );
        const isOptionSelectedAnywhere = treatmentOptionIds.some(
          (optId: number) => allSelectedOptionIds.includes(optId)
        );

        if (!isOptionSelectedAnywhere) {
          treatmentsMissingOptions.push(treatmentData.TreatmentName);
        }
      }
    }

    if (treatmentsMissingOptions.length > 0) {
      toast.error(
        `${formatMessage(
          "option_is_mandatory_for"
        )}: ${treatmentsMissingOptions.join(", ")}`
      );
      return false; // Prevent submit
    }
    return true;
  };

  const validationSchema = useMemo(
    () => BookingFormSchema(formatMessage, bookingManagementStore),
    [preferencesStore.language, formatMessage, bookingManagementStore.mapSlot?.MapSlots] // rebuild schema on language change
  );

  const handleRecovery = () => {
    console.log("💡 System recovered! Reloading page...");
    window.location.reload();
  };

  useLizeraStaleStateRecovery(handleRecovery);

  return (
    <>
      {/* Loader for various loading states */}
      <FormLoader
        loading={
          staffOptionsState.inProgress ||
          taxSettingState.inProgress ||
          storeOptionsState.inProgress ||
          timeSettingState.inProgress ||
          storeState.inProgress ||
          // getTreatmentOptionMenuListState.inProgress ||
          allCategoryState.inProgress ||
          addUpdateAppointmentState.inProgress ||
          authenticateCustomerState.inProgress ||
          getByIdReservationSettingState.inProgress ||
          getByIdConsumptionTaxState.inProgress
        }
      />

      {/* Show customer authentication popup if needed */}
      {props.showAuthorizeCustomerPopup && (
        <AuthenticateCustomerAccount
          businessTypeId={storeCodeDetails?.BusinessTypeId}
          appointmentData={bookingDetails}
          storeId={storeId}
          modalClosed={props.authorizeCustomerToggleHandler}
        />
      )}

      {props.showResetPasswordPopup && (
        <ZeroDurationTreatmentPopup
          modalClosed={() => {
            props.resetPasswordToggleHandler();
          }}
          title={formatMessage("booking_management")}
          message={formatMessage("zero_minute_treatment_alert_message")}
          isLoading={false}
        />
      )}

      {/* Top navigation bar for customers */}
      <CustomerTopNavbar />

      {/* Main booking form content if storeId is valid */}
      {storeId > 0 ? (
        <div className="booking-steps-wrapper">
          <Formik
            initialValues={initialData}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            innerRef={formikRef}
          >
            {(formikProps) => {
              if (preferencesStore.islanguageChanged) {
                formikProps.validateForm();
                preferencesStore.updateLanguageChangedFlag();
              }

              return (
                <div className="container-xl container-fluid">
                  <Form className="booking-form">
                    {/* Store name header */}
                    <h4 className="py-2 px-lg-5 py-md-3 px-3 border-bottom">
                      {getAllStoreOptions?.find((s) => s.id === storeId)
                        ?.value || "No Store Selected"}
                    </h4>
                    {/* Step indicator for booking steps */}
                    <StepIndicator
                      currentStep={currentStep}
                      // onStepClick={(step) =>
                      //   handleStepClick(formikProps.values, step)
                      // }
                      isStepAccessible={(step) =>
                        isStepAccessible(formikProps.values, step)
                      }
                    />
                    <div className="booking-content px-lg-5 px-3">
                      {/* Step 1: Service selection */}
                      {currentStep === 1 && (
                        <ServiceSelection
                          formikProps={formikProps}
                          storeId={storeId}
                          openNodes={openNodes}
                          setOpenNodes={setOpenNodes}
                          currentStep={currentStep}
                          setCurrentStep={setCurrentStep}
                        />
                      )}

                      {/* Step 2: Staff selection and calendar */}
                      {currentStep === 2 && (
                        <>
                          <StaffSelection
                            formikProps={formikProps}
                            storeId={storeId}
                          />

                          <Calendar
                            formikProps={formikProps}
                            storeId={storeId}
                          />
                        </>
                      )}

                      {/* Step 3: Confirmation details */}
                      {currentStep === 3 && (
                        <ConfirmationDetails
                          formikProps={formikProps}
                          storeDetails={storeCodeDetails}
                        />
                      )}

                      {/* Step 4: Booking complete or failed */}
                      {currentStep === 4 && (
                        <React.Fragment>
                          {/* <BookingComplete /> */}

                          {addUpdateAppointmentState.success == true ? (
                            <BookingComplete
                              StoreCode={storeCodeDetails?.StoreCode}
                            />
                          ) : addUpdateAppointmentState.error !== "" ? (
                            <BookingFailed
                              setCurrentStep={setCurrentStep}
                              formikProps={formikProps}
                            />
                          ) : (
                            ""
                          )}
                        </React.Fragment>
                      )}
                    </div>

                    {/* Navigation buttons for steps 1-3 */}
                    {currentStep < 4 && (
                      <div className="d-flex justify-content-between align-items-center booking-stepper-buttons px-lg-5 p-3 py-lg-4">
                        {/* Return/back button for steps > 1 */}
                        <button
                          type="button"
                          className="btn btn-outline-secondary px-4  px-md-5"
                          onClick={() => {
                            setCurrentStep(Math.max(currentStep - 1, 1));
                            if (currentStep == 3) {
                              formikProps.setFieldValue("selectedDate", null);
                              formikProps.setFieldValue("agreedToTerms", false);
                              formikProps.setFieldTouched(
                                "agreedToTerms",
                                false,
                                false
                              );
                              formikProps.setFieldValue("agreeToPrecaution", false);
                              formikProps.setFieldTouched(
                                "agreeToPrecaution",
                                false,
                                false
                              );
                              formikProps.setFieldValue("dmAgreeToTerms", false);
                              formikProps.setFieldTouched(
                                "dmAgreeToTerms",
                                false,
                                false
                              );
                            }
                            if (currentStep == 2) {
                              GetAllCategoriesServiceReservation(
                                storeCodeDetails?.BusinessTypeId
                              );
                            }
                            if (currentStep == 1) {
                              history.push(`/Store/${storeCode}`);
                            }
                          }}
                        >
                          <FormattedMessage id="return" />
                        </button>

                        {/* Confirm booking button on step 3, otherwise Next button */}
                        {currentStep === 3 ? (
                          <button
                            type="button"
                            className="btn btn-info fs-lg btn-lg py-3 px-4 px-md-5"
                            disabled={
                              !(
                                formikProps.values.agreedToTerms &&
                                formikProps.values.agreeToPrecaution
                              )
                            }
                            onClick={() => formikProps.handleSubmit()}
                          >
                            <FormattedMessage id="confirm_your_booking" />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-dark px-4 px-md-5"
                            onClick={() => {
                              // Validate the current step
                              let canProceed = false;

                              if (currentStep === 1) {
                                if (
                                  Number(
                                    totalDurationWithZeroTimeTreatmentCheck()
                                  ) == 0
                                ) {
                                  props.resetPasswordToggleHandler();
                                  return;
                                }

                                formikProps.validateField("selectedServices");
                                const isValidatedSuccessfully =
                                  validateOptionMandatoryForTreatment(
                                    formikProps.values.selectedServices
                                  );
                                if (!isValidatedSuccessfully) return;
                                canProceed =
                                  formikProps.values.selectedServices.length >
                                  0;
                              } else if (currentStep === 2) {
                                formikProps.validateField("selectedStaff");
                                formikProps.validateField("selectedDate");
                                canProceed =
                                  Boolean(formikProps.values.selectedStaff) &&
                                  Boolean(formikProps.values.selectedDate);
                              }

                              if (canProceed) {
                                setCurrentStep(Math.min(currentStep + 1, 3));
                              } else {
                                // Show validation messages by touching the fields
                                if (currentStep === 1) {
                                  formikProps.setFieldTouched(
                                    "selectedServices",
                                    true,
                                    true
                                  );
                                } else if (currentStep === 2) {
                                  formikProps.setFieldTouched(
                                    "selectedStaff",
                                    true,
                                    true
                                  );
                                  formikProps.setFieldTouched(
                                    "selectedDate",
                                    true,
                                    true
                                  );
                                }
                              }
                            }}
                          >
                            <FormattedMessage id="next" />
                          </button>
                        )}
                      </div>
                    )}

                    {/* Show warning if terms are not agreed on step 3 */}
                    {currentStep === 3 && (
                      <div className="px-lg-5 px-3 pb-4">
                        {!(
                          formikProps.values.agreedToTerms &&
                          formikProps.values.agreeToPrecaution
                        ) && (
                          <p className="text-danger text-end">
                            <FormattedMessage id="please_agree_to_terms" />
                          </p>
                        )}
                      </div>
                    )}
                  </Form>
                </div>
              );
            }}
          </Formik>
        </div>
      ) : (
        // Show message if no store is selected
        <div className="booking-form container-fluid">
          <h1>
            <FormattedMessage id="please_select_store" />
          </h1>
        </div>
      )}
    </>
  );
};

export default ResetPasswordWindowPopupHOC(
  AuthorizeCustomerPopupHOC(observer(BookingManagement))
);
